// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * Grissemann Hub API
 * The API for communication with Grissemann eCommerce Hub.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * A delivery or billing address for a customer. Note that there must be exactly one billing address.
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {number}
     * @memberof AddressDto
     */
    id?: number;
    /**
     * Company name
     * @type {string}
     * @memberof AddressDto
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    streetNr: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    postCode: string;
    /**
     * See https://confluence.eurogast.at/pages/viewpage.action?pageId=3770513
     * @type {string}
     * @memberof AddressDto
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    salutation: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    telephone: string;
}
/**
 * 
 * @export
 * @interface AllContactsBlockDto
 */
export interface AllContactsBlockDto {
    /**
     * 
     * @type {Array<ContactDepartmentDto>}
     * @memberof AllContactsBlockDto
     */
    departments: Array<ContactDepartmentDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AllergenDto {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
    H = 'H',
    L = 'L',
    M = 'M',
    N = 'N',
    O = 'O',
    P = 'P',
    R = 'R'
}

/**
 * 
 * @export
 * @interface AttributeFacetValueDto
 */
export interface AttributeFacetValueDto {
    /**
     * 
     * @type {string}
     * @memberof AttributeFacetValueDto
     */
    value: string;
    /**
     * How many products for given query have this attribute
     * @type {number}
     * @memberof AttributeFacetValueDto
     */
    resultCount: number;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/bigproducts+-+Fokussierte+Produkte
 * @export
 * @interface BigProductsBlockDto
 */
export interface BigProductsBlockDto {
    /**
     * 
     * @type {string}
     * @memberof BigProductsBlockDto
     */
    title?: string;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof BigProductsBlockDto
     */
    products: Array<ProductDto>;
    /**
     * 
     * @type {string}
     * @memberof BigProductsBlockDto
     */
    backgroundImagePath?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum BlockAlignmentDto {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
    CENTER = 'CENTER'
}

/**
 * Wraps a block object, retaining type information.
 * @export
 * @interface BlockDto
 */
export interface BlockDto {
    /**
     * Any block DTO
     * @type {object}
     * @memberof BlockDto
     */
    block: object;
    /**
     * 
     * @type {string}
     * @memberof BlockDto
     */
    type: string;
}
/**
 * Specifies a request for a single page while browsing essential products. Note that, contrary to usual behaviour, an EssentialProductFilterDto of IGNORE will be treated like SHOWN_ONLY in this request.
 * @export
 * @interface BrowseRequestDto
 */
export interface BrowseRequestDto {
    /**
     * 
     * @type {ProductSearchFilterDto}
     * @memberof BrowseRequestDto
     */
    filter?: ProductSearchFilterDto;
    /**
     * 
     * @type {PageRequestDto}
     * @memberof BrowseRequestDto
     */
    page?: PageRequestDto;
}
/**
 * Single button in a button block
 * @export
 * @interface ButtonBlockButtonDto
 */
export interface ButtonBlockButtonDto {
    /**
     * 
     * @type {ButtonTypeDto}
     * @memberof ButtonBlockButtonDto
     */
    type: ButtonTypeDto;
    /**
     * 
     * @type {BlockAlignmentDto}
     * @memberof ButtonBlockButtonDto
     */
    alignment: BlockAlignmentDto;
    /**
     * 
     * @type {string}
     * @memberof ButtonBlockButtonDto
     */
    caption: string;
    /**
     * 
     * @type {LinkDto}
     * @memberof ButtonBlockButtonDto
     */
    link?: LinkDto;
    /**
     * 
     * @type {string}
     * @memberof ButtonBlockButtonDto
     */
    icon?: string;
}
/**
 * https://confluence.grissemann.at/pages/viewpage.action?pageId=70127894
 * @export
 * @interface ButtonBlockDto
 */
export interface ButtonBlockDto {
    /**
     * 
     * @type {Array<ButtonBlockButtonDto>}
     * @memberof ButtonBlockDto
     */
    buttons: Array<ButtonBlockButtonDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ButtonTypeDto {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY'
}

/**
 * Represents full information about a category, including children
 * @export
 * @interface CategoryDto
 */
export interface CategoryDto {
    /**
     * The absolute id of the category of this product, with each node in the category tree separated by a pipe. The example represents the child 20 of 07, which is a child of the root category 02.
     * @type {string}
     * @memberof CategoryDto
     */
    id: string;
    /**
     * The absolute id of the parent category, empty string if this is a root category.
     * @type {string}
     * @memberof CategoryDto
     */
    parentId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    name: string;
    /**
     * Whether this category is virtual, that means that it cannot be the main category of a product.
     * @type {boolean}
     * @memberof CategoryDto
     */
    virtual: boolean;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    thumbnailImagePath?: string;
}
/**
 * 
 * @export
 * @interface CategoryFacetDto
 */
export interface CategoryFacetDto {
    /**
     * 
     * @type {CategoryDto}
     * @memberof CategoryFacetDto
     */
    category?: CategoryDto;
    /**
     * How many products for given query are in this category
     * @type {number}
     * @memberof CategoryFacetDto
     */
    resultCount?: number;
}
/**
 * 
 * @export
 * @interface ContactBlockDto
 */
export interface ContactBlockDto {
    /**
     * 
     * @type {string}
     * @memberof ContactBlockDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ContactBlockDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContactBlockDto
     */
    role: string;
    /**
     * Resolved path to the referenced images
     * @type {string}
     * @memberof ContactBlockDto
     */
    imagePath: string;
    /**
     * 
     * @type {string}
     * @memberof ContactBlockDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactBlockDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactBlockDto
     */
    fax?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactBlockDto
     */
    extrainfo?: string;
}
/**
 * 
 * @export
 * @interface ContactDepartmentDto
 */
export interface ContactDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof ContactDepartmentDto
     */
    name?: string;
    /**
     * 
     * @type {Array<ContactBlockDto>}
     * @memberof ContactDepartmentDto
     */
    contacts: Array<ContactBlockDto>;
}
/**
 * 
 * @export
 * @interface CouponDto
 */
export interface CouponDto {
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof CouponDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof CouponDto
     */
    validTo: Date;
    /**
     * 
     * @type {DiscountRuleDto}
     * @memberof CouponDto
     */
    discountRule: DiscountRuleDto;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    discountValue: number;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    discountValueString?: string;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    minimumCartValue?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CouponDto
     */
    useUnlimited?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponDto
     */
    targetProductSkus: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponDto
     */
    targetCategoryIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponDto
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface DeliveryDayDto
 */
export interface DeliveryDayDto {
    /**
     * Following the ISO-8601 standard => 1 (Monday) - 7 (Sunday)
     * @type {number}
     * @memberof DeliveryDayDto
     */
    weekDay: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDayDto
     */
    date: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryDayDto
     */
    isToday: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryDayDto
     */
    multiColumn: boolean;
    /**
     * 
     * @type {Array<DeliverySlotDto>}
     * @memberof DeliveryDayDto
     */
    slots: Array<DeliverySlotDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DeliveryMethodDto {
    PICKUP = 'PICKUP',
    DELIVERY = 'DELIVERY'
}

/**
 * 
 * @export
 * @interface DeliverySlotDto
 */
export interface DeliverySlotDto {
    /**
     * 
     * @type {number}
     * @memberof DeliverySlotDto
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof DeliverySlotDto
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof DeliverySlotDto
     */
    endTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof DeliverySlotDto
     */
    orderDeadline: Date;
    /**
     * 
     * @type {DeliveryMethodDto}
     * @memberof DeliverySlotDto
     */
    deliveryMethod: DeliveryMethodDto;
    /**
     * 
     * @type {Array<ShippingFeeDto>}
     * @memberof DeliverySlotDto
     */
    shippingFees: Array<ShippingFeeDto>;
    /**
     * the column this delivery slot should be displayed in. usually 1 or 2.
     * @type {number}
     * @memberof DeliverySlotDto
     */
    column: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DiscountRuleDto {
    FREESHIPPING = 'FREE_SHIPPING',
    FIXEDVALUE = 'FIXED_VALUE',
    PERCENT = 'PERCENT'
}

/**
 * https://confluence.grissemann.at/display/SRGPROJ/dynpage+-+Freie+Seite
 * @export
 * @interface DynPageDto
 */
export interface DynPageDto {
    /**
     * 
     * @type {string}
     * @memberof DynPageDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DynPageDto
     */
    teaserText?: string;
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof DynPageDto
     */
    blocks: Array<BlockDto>;
}
/**
 * 
 * @export
 * @interface ErrorDto
 */
export interface ErrorDto {
    /**
     * The type of error that occurred. This key is equal to a key of the frontend enum \'ErrorKeys\'.
     * @type {string}
     * @memberof ErrorDto
     */
    error: string;
    /**
     * Contains additional parameters that are used for displaying the error message in the frontend. This depends on the error type and can be i.e. the product sku etc.
     * @type {Array<string>}
     * @memberof ErrorDto
     */
    parameters?: Array<string>;
}
/**
 * An item in the essence list of a user. This usually corresponds to a product that was previously ordered from the shop or purchased over other channels.
 * @export
 * @interface EssenceItemDto
 */
export interface EssenceItemDto {
    /**
     * The UUID of the user
     * @type {string}
     * @memberof EssenceItemDto
     */
    userId: string;
    /**
     * The Stock Keeping Unit id of the product represented by this item.
     * @type {string}
     * @memberof EssenceItemDto
     */
    sku: string;
    /**
     * The abbreviation of the unit that was ordered.
     * @type {string}
     * @memberof EssenceItemDto
     */
    unitAbbreviation?: string;
    /**
     * 
     * @type {string}
     * @memberof EssenceItemDto
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof EssenceItemDto
     */
    quantity?: number;
}
/**
 * Filters products by whether they occur in the essence list of a customer. IGNORE (the default) means to also show non-essential products.
 * @export
 * @enum {string}
 */
export enum EssentialProductFilterDto {
    IGNORE = 'IGNORE',
    SHOWNONLY = 'SHOWN_ONLY',
    HIDDENONLY = 'HIDDEN_ONLY',
    ALL = 'ALL'
}

/**
 * 
 * @export
 * @interface EventBlockDto
 */
export interface EventBlockDto {
    /**
     * 
     * @type {string}
     * @memberof EventBlockDto
     */
    name: string;
    /**
     * Resolved path to the referenced image
     * @type {string}
     * @memberof EventBlockDto
     */
    imagePath: string;
    /**
     * 
     * @type {string}
     * @memberof EventBlockDto
     */
    validFrom: string;
    /**
     * 
     * @type {string}
     * @memberof EventBlockDto
     */
    validTo: string;
    /**
     * 
     * @type {string}
     * @memberof EventBlockDto
     */
    description?: string;
    /**
     * Hex value of the background color
     * @type {string}
     * @memberof EventBlockDto
     */
    backgroundColor?: string;
    /**
     * 
     * @type {LinkDto}
     * @memberof EventBlockDto
     */
    link?: LinkDto;
}
/**
 * 
 * @export
 * @interface FeatureBlockDto
 */
export interface FeatureBlockDto {
    /**
     * 
     * @type {string}
     * @memberof FeatureBlockDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureBlockDto
     */
    teaser?: string;
    /**
     * 
     * @type {LinkDto}
     * @memberof FeatureBlockDto
     */
    link?: LinkDto;
    /**
     * 
     * @type {LinkDto}
     * @memberof FeatureBlockDto
     */
    extraLink?: LinkDto;
    /**
     * 
     * @type {string}
     * @memberof FeatureBlockDto
     */
    image?: string;
}
/**
 * A group of feature blocks
 * @export
 * @interface FeatureBlockGroupDto
 */
export interface FeatureBlockGroupDto {
    /**
     * 
     * @type {Array<FeatureBlockDto>}
     * @memberof FeatureBlockGroupDto
     */
    elements: Array<FeatureBlockDto>;
}
/**
 * 
 * @export
 * @interface FlyoutCategoryDto
 */
export interface FlyoutCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof FlyoutCategoryDto
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof FlyoutCategoryDto
     */
    imagePath?: string;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/footer+-+Footer
 * @export
 * @interface FooterFragmentDto
 */
export interface FooterFragmentDto {
    /**
     * 
     * @type {Array<FooterTopLinkDto>}
     * @memberof FooterFragmentDto
     */
    topLinks: Array<FooterTopLinkDto>;
    /**
     * 
     * @type {Array<MenuDto>}
     * @memberof FooterFragmentDto
     */
    bottomLinks: Array<MenuDto>;
    /**
     * 
     * @type {Array<ImageLinkDto>}
     * @memberof FooterFragmentDto
     */
    extraImages: Array<ImageLinkDto>;
}
/**
 * https://confluence.grissemann.at/pages/viewpage.action?pageId=70127828
 * @export
 * @interface FooterTopLinkDto
 */
export interface FooterTopLinkDto {
    /**
     * 
     * @type {LinkDto}
     * @memberof FooterTopLinkDto
     */
    mainLink?: LinkDto;
    /**
     * 
     * @type {Array<ImageLinkDto>}
     * @memberof FooterTopLinkDto
     */
    items: Array<ImageLinkDto>;
}
/**
 * A form containing form fields
 * @export
 * @interface FormBlockDto
 */
export interface FormBlockDto {
    /**
     * 
     * @type {string}
     * @memberof FormBlockDto
     */
    key: string;
    /**
     * path to the node containing the form for referencing submitted forms to cms content
     * @type {string}
     * @memberof FormBlockDto
     */
    path: string;
    /**
     * language code of the form
     * @type {string}
     * @memberof FormBlockDto
     */
    language: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof FormBlockDto
     */
    fields: Array<object>;
}
/**
 * 
 * @export
 * @interface FormChoiceDto
 */
export interface FormChoiceDto {
    /**
     * 
     * @type {string}
     * @memberof FormChoiceDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof FormChoiceDto
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormChoiceDto
     */
    required: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormChoiceDto
     */
    choices?: Array<string>;
}
/**
 * 
 * @export
 * @interface FormSubmissionFieldDto
 */
export interface FormSubmissionFieldDto {
    /**
     * 
     * @type {string}
     * @memberof FormSubmissionFieldDto
     */
    fieldLabel: string;
    /**
     * 
     * @type {string}
     * @memberof FormSubmissionFieldDto
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface FormTextDto
 */
export interface FormTextDto {
    /**
     * 
     * @type {string}
     * @memberof FormTextDto
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormTextDto
     */
    multiline?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormTextDto
     */
    required: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormTextDto
     */
    regex?: string;
}
/**
 * 
 * @export
 * @interface FutureEventsBlockDto
 */
export interface FutureEventsBlockDto {
    /**
     * 
     * @type {Array<EventBlockDto>}
     * @memberof FutureEventsBlockDto
     */
    events: Array<EventBlockDto>;
    /**
     * 
     * @type {string}
     * @memberof FutureEventsBlockDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FutureEventsBlockDto
     */
    subtitle?: string;
}
/**
 * Specifies the result of requesting a page of grouped products.
 * @export
 * @interface GroupedProductsDto
 */
export interface GroupedProductsDto {
    /**
     * 
     * @type {ProductSearchFilterDto}
     * @memberof GroupedProductsDto
     */
    filter?: ProductSearchFilterDto;
    /**
     * The wall clock time that passed between sending the request to the index and having received the full result, in milliseconds.
     * @type {number}
     * @memberof GroupedProductsDto
     */
    queryDurationMs?: number;
    /**
     * The groupings of products contained in this page.
     * @type {Array<ProductGroupingDto>}
     * @memberof GroupedProductsDto
     */
    groupings: Array<ProductGroupingDto>;
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof GroupedProductsDto
     */
    page: PageMetadataDto;
    /**
     * 
     * @type {ProductFacetsDto}
     * @memberof GroupedProductsDto
     */
    facets: ProductFacetsDto;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/header+-+Header
 * @export
 * @interface HeaderFragmentDto
 */
export interface HeaderFragmentDto {
    /**
     * 
     * @type {Array<LinkDto>}
     * @memberof HeaderFragmentDto
     */
    topLinks: Array<LinkDto>;
    /**
     * 
     * @type {string}
     * @memberof HeaderFragmentDto
     */
    categoryMenuTitle?: string;
    /**
     * 
     * @type {Array<MenuDto>}
     * @memberof HeaderFragmentDto
     */
    extraMenus: Array<MenuDto>;
    /**
     * 
     * @type {string}
     * @memberof HeaderFragmentDto
     */
    flyoutLinksTitle?: string;
    /**
     * 
     * @type {Array<LinkDto>}
     * @memberof HeaderFragmentDto
     */
    flyoutLinks: Array<LinkDto>;
    /**
     * 
     * @type {string}
     * @memberof HeaderFragmentDto
     */
    flyoutHighlightsTitle?: string;
    /**
     * 
     * @type {Array<HighlightLinkDto>}
     * @memberof HeaderFragmentDto
     */
    flyoutHighlights: Array<HighlightLinkDto>;
    /**
     * 
     * @type {Array<FlyoutCategoryDto>}
     * @memberof HeaderFragmentDto
     */
    flyoutCategories?: Array<FlyoutCategoryDto>;
}
/**
 * https://confluence.grissemann.at/pages/viewpage.action?pageId=70127926
 * @export
 * @interface HeadingBlockDto
 */
export interface HeadingBlockDto {
    /**
     * 
     * @type {number}
     * @memberof HeadingBlockDto
     */
    level: number;
    /**
     * 
     * @type {string}
     * @memberof HeadingBlockDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof HeadingBlockDto
     */
    subtitle?: string;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/highlightlink+-+Link+mit+Beschreibung
 * @export
 * @interface HighlightLinkDto
 */
export interface HighlightLinkDto {
    /**
     * 
     * @type {LinkDto}
     * @memberof HighlightLinkDto
     */
    link: LinkDto;
    /**
     * 
     * @type {string}
     * @memberof HighlightLinkDto
     */
    teaserText: string;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/imageblock+-+Bild
 * @export
 * @interface ImageBlockDto
 */
export interface ImageBlockDto {
    /**
     * 
     * @type {Array<ImageBlockImageDto>}
     * @memberof ImageBlockDto
     */
    images: Array<ImageBlockImageDto>;
}
/**
 * Single image in a collapsed imageblock
 * @export
 * @interface ImageBlockImageDto
 */
export interface ImageBlockImageDto {
    /**
     * Resolved path to the referenced image
     * @type {string}
     * @memberof ImageBlockImageDto
     */
    imagePath: string;
    /**
     * 
     * @type {LinkDto}
     * @memberof ImageBlockImageDto
     */
    link?: LinkDto;
    /**
     * 
     * @type {boolean}
     * @memberof ImageBlockImageDto
     */
    originalSize: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImageBlockImageDto
     */
    copyright?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageBlockImageDto
     */
    buttonCaption?: string;
}
/**
 * 
 * @export
 * @interface ImageLinkDto
 */
export interface ImageLinkDto {
    /**
     * 
     * @type {string}
     * @memberof ImageLinkDto
     */
    caption: string;
    /**
     * 
     * @type {string}
     * @memberof ImageLinkDto
     */
    target: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImageLinkDto
     */
    newTab: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImageLinkDto
     */
    imagePath: string;
}
/**
 * 
 * @export
 * @interface ImageTileBlockDto
 */
export interface ImageTileBlockDto {
    /**
     * 
     * @type {ImageLinkDto}
     * @memberof ImageTileBlockDto
     */
    imageLink?: ImageLinkDto;
    /**
     * 
     * @type {string}
     * @memberof ImageTileBlockDto
     */
    copyright?: string;
}
/**
 * 
 * @export
 * @interface ImageTileGroupBlockDto
 */
export interface ImageTileGroupBlockDto {
    /**
     * 
     * @type {string}
     * @memberof ImageTileGroupBlockDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageTileGroupBlockDto
     */
    subtitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageTileGroupBlockDto
     */
    backgroundColor?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageTileGroupBlockDto
     */
    tilesPerLine?: number;
    /**
     * 
     * @type {LinkDto}
     * @memberof ImageTileGroupBlockDto
     */
    link?: LinkDto;
    /**
     * 
     * @type {BlockAlignmentDto}
     * @memberof ImageTileGroupBlockDto
     */
    alignCaption?: BlockAlignmentDto;
    /**
     * 
     * @type {Array<ImageTileBlockDto>}
     * @memberof ImageTileGroupBlockDto
     */
    elements: Array<ImageTileBlockDto>;
}
/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    documentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    documentType?: InvoiceDtoDocumentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDto
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    information?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InvoiceDtoDocumentTypeEnum {
    Invoice = 'invoice',
    Creditmemo = 'creditmemo',
    Deliverynote = 'deliverynote'
}

/**
 * 
 * @export
 * @interface InvoicesDto
 */
export interface InvoicesDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof InvoicesDto
     */
    page: PageMetadataDto;
    /**
     * 
     * @type {Array<InvoiceDto>}
     * @memberof InvoicesDto
     */
    invoices: Array<InvoiceDto>;
}
/**
 * 
 * @export
 * @interface LinkDto
 */
export interface LinkDto {
    /**
     * 
     * @type {string}
     * @memberof LinkDto
     */
    caption: string;
    /**
     * 
     * @type {string}
     * @memberof LinkDto
     */
    target: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkDto
     */
    newTab: boolean;
}
/**
 * A facet that maps a product property to the amount of associated documents and provides a localised display name.
 * @export
 * @interface LocalizedAttributeFacetDto
 */
export interface LocalizedAttributeFacetDto {
    /**
     * 
     * @type {string}
     * @memberof LocalizedAttributeFacetDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizedAttributeFacetDto
     */
    displayName: string;
    /**
     * 
     * @type {Array<AttributeFacetValueDto>}
     * @memberof LocalizedAttributeFacetDto
     */
    values: Array<AttributeFacetValueDto>;
}
/**
 * 
 * @export
 * @interface ManagementOrderRequestDto
 */
export interface ManagementOrderRequestDto {
    /**
     * 
     * @type {OrderFilterDto}
     * @memberof ManagementOrderRequestDto
     */
    filter?: OrderFilterDto;
    /**
     * 
     * @type {PageRequestDto}
     * @memberof ManagementOrderRequestDto
     */
    page?: PageRequestDto;
}
/**
 * 
 * @export
 * @interface ManagementUserDto
 */
export interface ManagementUserDto {
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    salutation: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    birthDate: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    assignedShopCode: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementUserDto
     */
    megacardNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof ManagementUserDto
     */
    updateTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ManagementUserDto
     */
    creationTime: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ManagementUserDto
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ManagementUserDto
     */
    essenceImported: boolean;
}
/**
 * 
 * @export
 * @interface ManagementUserRequestDto
 */
export interface ManagementUserRequestDto {
    /**
     * 
     * @type {UserFilterDto}
     * @memberof ManagementUserRequestDto
     */
    filter?: UserFilterDto;
    /**
     * 
     * @type {PageRequestDto}
     * @memberof ManagementUserRequestDto
     */
    page?: PageRequestDto;
}
/**
 * Key for a Megacard
 * @export
 * @interface MegacardRequestDto
 */
export interface MegacardRequestDto {
    /**
     * Number of the Megacard
     * @type {string}
     * @memberof MegacardRequestDto
     */
    number: string;
    /**
     * Post code of the assigned address. Used as a second factor for authentication, to prevent users from accessing Megacard address information of others by guessing the number.
     * @type {string}
     * @memberof MegacardRequestDto
     */
    postCode: string;
}
/**
 * https://confluence.grissemann.at/pages/viewpage.action?pageId=70127828
 * @export
 * @interface MenuDto
 */
export interface MenuDto {
    /**
     * 
     * @type {LinkDto}
     * @memberof MenuDto
     */
    mainLink?: LinkDto;
    /**
     * 
     * @type {Array<LinkDto>}
     * @memberof MenuDto
     */
    items: Array<LinkDto>;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/multicols+-+Mehrspaltigkeit
 * @export
 * @interface MultiColumnBlockDto
 */
export interface MultiColumnBlockDto {
    /**
     * Blocks in the left column
     * @type {Array<BlockDto>}
     * @memberof MultiColumnBlockDto
     */
    blocksLeft: Array<BlockDto>;
    /**
     * Blocks in the right column
     * @type {Array<BlockDto>}
     * @memberof MultiColumnBlockDto
     */
    blocksRight: Array<BlockDto>;
    /**
     * Width of the left column in terms of the right column size.
     * @type {number}
     * @memberof MultiColumnBlockDto
     */
    leftColumnGrow?: number;
    /**
     * Hex value of the background color
     * @type {string}
     * @memberof MultiColumnBlockDto
     */
    backgroundColor?: string;
}
/**
 * The metadata of an item and multiple shopping list ids.
 * @export
 * @interface MultipleShoppingListsItemDto
 */
export interface MultipleShoppingListsItemDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof MultipleShoppingListsItemDto
     */
    shoppingListIds: Array<number>;
    /**
     * 
     * @type {ShoppingListItemMetadataDto}
     * @memberof MultipleShoppingListsItemDto
     */
    shoppingListItem: ShoppingListItemMetadataDto;
}
/**
 * 
 * @export
 * @interface OrderDto
 */
export interface OrderDto {
    /**
     * The globally-unique id of this order.
     * @type {string}
     * @memberof OrderDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    driverNotice?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    userId?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderDto
     */
    deliverySlotStartTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderDto
     */
    deliverySlotEndTime?: Date;
    /**
     * 
     * @type {DeliveryMethodDto}
     * @memberof OrderDto
     */
    deliveryMethod?: DeliveryMethodDto;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof OrderDto
     */
    paymentMethod?: PaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    email?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof OrderDto
     */
    deliveryAddress?: AddressDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof OrderDto
     */
    billingAddress?: AddressDto;
    /**
     * 
     * @type {Array<ShoppingCartItemGroupDto>}
     * @memberof OrderDto
     */
    orderItemGroups?: Array<ShoppingCartItemGroupDto>;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    totalItemPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    totalDeposit: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    totalDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    totalPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    couponDiscount?: number;
}
/**
 * 
 * @export
 * @interface OrderFilterDto
 */
export interface OrderFilterDto {
    /**
     * 
     * @type {Date}
     * @memberof OrderFilterDto
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderFilterDto
     */
    to?: Date;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/order+-+Fragmente+Bestellprozess
 * @export
 * @interface OrderFragmentDto
 */
export interface OrderFragmentDto {
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof OrderFragmentDto
     */
    sideBlocks?: Array<BlockDto>;
    /**
     * Resolved path to the referenced image
     * @type {string}
     * @memberof OrderFragmentDto
     */
    imageDelivery?: string;
    /**
     * Resolved path to the referenced image
     * @type {string}
     * @memberof OrderFragmentDto
     */
    imagePickup?: string;
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof OrderFragmentDto
     */
    summaryBlocks?: Array<BlockDto>;
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof OrderFragmentDto
     */
    addressBlocks?: Array<BlockDto>;
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof OrderFragmentDto
     */
    postDelivery?: Array<BlockDto>;
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof OrderFragmentDto
     */
    postPickup?: Array<BlockDto>;
    /**
     * 
     * @type {string}
     * @memberof OrderFragmentDto
     */
    pickupDeadline: string;
    /**
     * 
     * @type {string}
     * @memberof OrderFragmentDto
     */
    pickupLocation: string;
    /**
     * 
     * @type {string}
     * @memberof OrderFragmentDto
     */
    postServiceHotline: string;
}
/**
 * 
 * @export
 * @interface OrderPaymentResponseDto
 */
export interface OrderPaymentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentResponseDto
     */
    responseBase64: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentResponseDto
     */
    responseSignatureBase64: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentResponseDto
     */
    responseSignatureAlgorithm: string;
}
/**
 * Bundles address information for an order. If any of the address ids is null, then addresses will be created with the *ToCreate information if present. Address ids must not be provided for guest orders.
 * @export
 * @interface OrderSubmitAddressesDto
 */
export interface OrderSubmitAddressesDto {
    /**
     * id of existing delivery address, null to create new
     * @type {number}
     * @memberof OrderSubmitAddressesDto
     */
    deliveryAddressId?: number;
    /**
     * id of existing billing address, null to create new
     * @type {number}
     * @memberof OrderSubmitAddressesDto
     */
    billingAddressId?: number;
    /**
     * 
     * @type {AddressDto}
     * @memberof OrderSubmitAddressesDto
     */
    deliveryAddressToCreate?: AddressDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof OrderSubmitAddressesDto
     */
    billingAddressToCreate?: AddressDto;
}
/**
 * Specification of an order to submit. Given delivery slot will be used as-is, but the shipping fee information will be re-computed to prevent forgery. Email and birthday must be given if guest order, otherwise ignored.
 * @export
 * @interface OrderSubmitDto
 */
export interface OrderSubmitDto {
    /**
     * Guest cart id, ignored if logged in
     * @type {string}
     * @memberof OrderSubmitDto
     */
    shoppingCartId?: string;
    /**
     * 
     * @type {OrderSubmitAddressesDto}
     * @memberof OrderSubmitDto
     */
    addresses: OrderSubmitAddressesDto;
    /**
     * 
     * @type {DeliverySlotDto}
     * @memberof OrderSubmitDto
     */
    deliverySlot: DeliverySlotDto;
    /**
     * 
     * @type {string}
     * @memberof OrderSubmitDto
     */
    driverNotice?: string;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof OrderSubmitDto
     */
    requestedPaymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof OrderSubmitDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSubmitDto
     */
    birthday?: string;
    /**
     * URL to redirect to after an initial payment response has been received. This URL may contain a placeholder %%state%% that will be replaced with success, abort or fail depending on the state of the initial payment response. This URL may contain a placeholder %%orderId%% for the id of the corresponding order.
     * @type {string}
     * @memberof OrderSubmitDto
     */
    frontendRedirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSubmitDto
     */
    languageCode: string;
}
/**
 * Represents metadata regarding a single page of results to a paged query.
 * @export
 * @interface PageMetadataDto
 */
export interface PageMetadataDto {
    /**
     * The total number of elements that are available for the search query that this page is for.
     * @type {number}
     * @memberof PageMetadataDto
     */
    totalElements: number;
    /**
     * The total number of pages available for the search query that this page is for, assuming equal size.
     * @type {number}
     * @memberof PageMetadataDto
     */
    totalPages: number;
    /**
     * The zero-based index of this page.
     * @type {number}
     * @memberof PageMetadataDto
     */
    number: number;
    /**
     * The number of elements allowed per page. Note that there may actually be less elements if there are not enough results.
     * @type {number}
     * @memberof PageMetadataDto
     */
    size: number;
}
/**
 * 
 * @export
 * @interface PageRefBlockDto
 */
export interface PageRefBlockDto {
    /**
     * 
     * @type {Array<PageTeaserDto>}
     * @memberof PageRefBlockDto
     */
    teasers?: Array<PageTeaserDto>;
}
/**
 * 
 * @export
 * @interface PageRequestDto
 */
export interface PageRequestDto {
    /**
     * the index of the page to retrieve
     * @type {number}
     * @memberof PageRequestDto
     */
    page?: number;
    /**
     * the amount of entries per page
     * @type {number}
     * @memberof PageRequestDto
     */
    size?: number;
    /**
     * the field to sort by, or null if unsorted
     * @type {string}
     * @memberof PageRequestDto
     */
    sortBy?: string;
    /**
     * ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
     * @type {string}
     * @memberof PageRequestDto
     */
    sortDirection?: string;
}
/**
 * 
 * @export
 * @interface PageTeaserDto
 */
export interface PageTeaserDto {
    /**
     * 
     * @type {string}
     * @memberof PageTeaserDto
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof PageTeaserDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PageTeaserDto
     */
    teaserText?: string;
    /**
     * 
     * @type {string}
     * @memberof PageTeaserDto
     */
    teaserImagePath?: string;
}
/**
 * 
 * @export
 * @interface PagedCouponsDto
 */
export interface PagedCouponsDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof PagedCouponsDto
     */
    page: PageMetadataDto;
    /**
     * 
     * @type {Array<CouponDto>}
     * @memberof PagedCouponsDto
     */
    coupons: Array<CouponDto>;
}
/**
 * 
 * @export
 * @interface PagedManagementUsersDto
 */
export interface PagedManagementUsersDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof PagedManagementUsersDto
     */
    page: PageMetadataDto;
    /**
     * 
     * @type {Array<ManagementUserDto>}
     * @memberof PagedManagementUsersDto
     */
    users: Array<ManagementUserDto>;
}
/**
 * 
 * @export
 * @interface PagedOrdersDto
 */
export interface PagedOrdersDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof PagedOrdersDto
     */
    page: PageMetadataDto;
    /**
     * 
     * @type {Array<OrderDto>}
     * @memberof PagedOrdersDto
     */
    orders: Array<OrderDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PaymentMethodDto {
    CASH = 'CASH',
    PAYPAL = 'PAYPAL',
    CREDITCARD = 'CREDIT_CARD',
    SOFORT = 'SOFORT'
}

/**
 * 
 * @export
 * @interface PaymentStartDto
 */
export interface PaymentStartDto {
    /**
     * Whether the payment has already been authorised, without needing a redirect. This only works in some cases with some payment providers, e.g. cash payment will always be authorised immediately. In this case, the order will already be submitted. This means that no further action is required to start processing. If this is true, no url will be provided.
     * @type {boolean}
     * @memberof PaymentStartDto
     */
    completed: boolean;
    /**
     * A url for loading the viveum widget for payment process in frontend. This will be provided if and only if completed is false.
     * @type {string}
     * @memberof PaymentStartDto
     */
    widgetUrl?: string;
    /**
     * Url to which the widget will redirect after a finished payment. This will be provided if and only if completed is false.
     * @type {string}
     * @memberof PaymentStartDto
     */
    redirectUrl?: string;
    /**
     * Payment Brand which is used to control the viveum widget to load the desired payment provider.
     * @type {string}
     * @memberof PaymentStartDto
     */
    brand?: string;
    /**
     * Amount to pay in the transaction.
     * @type {number}
     * @memberof PaymentStartDto
     */
    transactionAmount?: number;
    /**
     * Chosen Payment Method from User.
     * @type {string}
     * @memberof PaymentStartDto
     */
    paymentMethod?: string;
}
/**
 * Determines how the discount value for a pick-response item is to be interpreted
 * @export
 * @enum {string}
 */
export enum PickResponseDiscountRuleDto {
    FIXEDVALUE = 'FIXED_VALUE',
    PERCENTAGE = 'PERCENTAGE'
}

/**
 * 
 * @export
 * @interface PickResponseDto
 */
export interface PickResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PickResponseDto
     */
    erpOrderId: string;
    /**
     * 
     * @type {PickResponseDtoOrder}
     * @memberof PickResponseDto
     */
    order: PickResponseDtoOrder;
    /**
     * 
     * @type {string}
     * @memberof PickResponseDto
     */
    tenant: string;
    /**
     * 
     * @type {string}
     * @memberof PickResponseDto
     */
    shopCode: string;
    /**
     * 
     * @type {string}
     * @memberof PickResponseDto
     */
    customerNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof PickResponseDto
     */
    pickClosedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof PickResponseDto
     */
    generalDiscountAmount: number;
    /**
     * 
     * @type {Array<PickResponseItemDto>}
     * @memberof PickResponseDto
     */
    items: Array<PickResponseItemDto>;
}
/**
 * 
 * @export
 * @interface PickResponseDtoOrder
 */
export interface PickResponseDtoOrder {
    /**
     * 
     * @type {string}
     * @memberof PickResponseDtoOrder
     */
    orderId: string;
}
/**
 * An item that was picked. The picked product need not be known to the webshop. Discount rule and value are optional, but both must be provided if a discount is applied.
 * @export
 * @interface PickResponseItemDto
 */
export interface PickResponseItemDto {
    /**
     * The unique number of this item in the pick response.
     * @type {number}
     * @memberof PickResponseItemDto
     */
    position: number;
    /**
     * SKU of the picked product
     * @type {string}
     * @memberof PickResponseItemDto
     */
    sku: string;
    /**
     * Display name of this item
     * @type {string}
     * @memberof PickResponseItemDto
     */
    name: string;
    /**
     * How much of the product was picked, relative to the unit
     * @type {number}
     * @memberof PickResponseItemDto
     */
    quantityPicked: number;
    /**
     * 
     * @type {PickResponseItemUnitDto}
     * @memberof PickResponseItemDto
     */
    unit: PickResponseItemUnitDto;
    /**
     * Abbreviation of the storage unit of the product
     * @type {string}
     * @memberof PickResponseItemDto
     */
    storageUnitAbbr: string;
    /**
     * Base price of the item, including tax
     * @type {number}
     * @memberof PickResponseItemDto
     */
    basePriceInclTax: number;
    /**
     * Deposit sum for this item
     * @type {number}
     * @memberof PickResponseItemDto
     */
    rowDepositAmount: number;
    /**
     * The rate at which this product\'s price is taxed
     * @type {number}
     * @memberof PickResponseItemDto
     */
    taxRate: number;
    /**
     * A comment for the submitter of the order, detailing special information relating to picking.
     * @type {string}
     * @memberof PickResponseItemDto
     */
    pickComment?: string;
    /**
     * 
     * @type {PickResponseDiscountRuleDto}
     * @memberof PickResponseItemDto
     */
    discountRule?: PickResponseDiscountRuleDto;
    /**
     * Value of the discount applied to this item, in EUR or %, depending on the applied rule.
     * @type {number}
     * @memberof PickResponseItemDto
     */
    discountValue?: number;
}
/**
 * The unit of a picked item
 * @export
 * @interface PickResponseItemUnitDto
 */
export interface PickResponseItemUnitDto {
    /**
     * Abbreviation of the unit
     * @type {string}
     * @memberof PickResponseItemUnitDto
     */
    abbr: string;
    /**
     * Ratio relative to the storage unit
     * @type {number}
     * @memberof PickResponseItemUnitDto
     */
    ratio: number;
}
/**
 * 
 * @export
 * @interface PriceRangeFilterDto
 */
export interface PriceRangeFilterDto {
    /**
     * 
     * @type {number}
     * @memberof PriceRangeFilterDto
     */
    priceFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceRangeFilterDto
     */
    priceTo?: number;
}
/**
 * 
 * @export
 * @interface ProductAttributeDto
 */
export interface ProductAttributeDto {
    /**
     * 
     * @type {string}
     * @memberof ProductAttributeDto
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAttributeDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAttributeDto
     */
    value?: string;
}
/**
 * Represents the base price (\"Grundpreisauszeichnung\") of a product.
 * @export
 * @interface ProductBasePriceDto
 */
export interface ProductBasePriceDto {
    /**
     * The quantity without a unit, as a string so that the exact value may be used.
     * @type {string}
     * @memberof ProductBasePriceDto
     */
    quantity?: string;
    /**
     * The display name of the quantity\'s unit.
     * @type {string}
     * @memberof ProductBasePriceDto
     */
    unit?: string;
    /**
     * Conversion factor for the reference unit, as a string so that the exact value may be used.
     * @type {string}
     * @memberof ProductBasePriceDto
     */
    refQuantity?: string;
    /**
     * Reference unit as string
     * @type {string}
     * @memberof ProductBasePriceDto
     */
    refUnit?: string;
}
/**
 * 
 * @export
 * @interface ProductBrandDto
 */
export interface ProductBrandDto {
    /**
     * 
     * @type {string}
     * @memberof ProductBrandDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductBrandDto
     */
    subName?: string;
}
/**
 * 
 * @export
 * @interface ProductCompletionRequestDto
 */
export interface ProductCompletionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ProductCompletionRequestDto
     */
    query?: string;
    /**
     * 
     * @type {ProductSearchFilterDto}
     * @memberof ProductCompletionRequestDto
     */
    filter?: ProductSearchFilterDto;
}
/**
 * 
 * @export
 * @interface ProductCompletionResponseDto
 */
export interface ProductCompletionResponseDto {
    /**
     * 
     * @type {Array<CategoryDto>}
     * @memberof ProductCompletionResponseDto
     */
    categories?: Array<CategoryDto>;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof ProductCompletionResponseDto
     */
    products?: Array<ProductDto>;
}
/**
 * 
 * @export
 * @interface ProductContactDto
 */
export interface ProductContactDto {
    /**
     * 
     * @type {string}
     * @memberof ProductContactDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductContactDto
     */
    address?: string;
}
/**
 * Represents a product in the store. Text attributes are localised in the language of the user that requested the product.
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * Stock Keeping Unit, the unique internal id for this product.
     * @type {string}
     * @memberof ProductDto
     */
    sku: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    description?: string;
    /**
     * 
     * @type {CategoryDto}
     * @memberof ProductDto
     */
    directCategory?: CategoryDto;
    /**
     * 
     * @type {Array<ProductImageDto>}
     * @memberof ProductDto
     */
    images?: Array<ProductImageDto>;
    /**
     * 
     * @type {ProductStatusDto}
     * @memberof ProductDto
     */
    status: ProductStatusDto;
    /**
     * 
     * @type {ProductUnitsDto}
     * @memberof ProductDto
     */
    units: ProductUnitsDto;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    netFillQuantity?: string;
    /**
     * 
     * @type {ProductBasePriceDto}
     * @memberof ProductDto
     */
    basePrice?: ProductBasePriceDto;
    /**
     * The price of the storage unit of this product before applying any discounts. Provided as a string so that the exact value is always used.
     * @type {string}
     * @memberof ProductDto
     */
    listPrice: string;
    /**
     * 
     * @type {ProductOfferPriceDto}
     * @memberof ProductDto
     */
    offerPrice?: ProductOfferPriceDto;
    /**
     * The effective price of the storage unit of this product, that is, the offer price if valid and less than the list price, otherwise, the list price. Provided as a string so that the exact value is always used.
     * @type {string}
     * @memberof ProductDto
     */
    effectivePrice: string;
    /**
     * 
     * @type {Array<AllergenDto>}
     * @memberof ProductDto
     */
    allergensContained?: Array<AllergenDto>;
    /**
     * 
     * @type {Array<AllergenDto>}
     * @memberof ProductDto
     */
    allergenTraces?: Array<AllergenDto>;
    /**
     * ingredients of the product.
     * @type {string}
     * @memberof ProductDto
     */
    ingredients?: string;
    /**
     * The abbreviations of the units that are in the essence list for this product.
     * @type {Array<string>}
     * @memberof ProductDto
     */
    essentialUnits?: Array<string>;
    /**
     * Deposit that will be returned upon return of the packaging, e.g. for bottles. (\"Pfand\")
     * @type {number}
     * @memberof ProductDto
     */
    deposit?: number;
    /**
     * 
     * @type {ProductBrandDto}
     * @memberof ProductDto
     */
    brand?: ProductBrandDto;
    /**
     * 
     * @type {ProductContactDto}
     * @memberof ProductDto
     */
    contact?: ProductContactDto;
    /**
     * 
     * @type {Array<ProductAttributeDto>}
     * @memberof ProductDto
     */
    attributes?: Array<ProductAttributeDto>;
    /**
     * 
     * @type {Array<ProductPropertyDto>}
     * @memberof ProductDto
     */
    properties?: Array<ProductPropertyDto>;
    /**
     * 
     * @type {Array<ServingNutritionDto>}
     * @memberof ProductDto
     */
    nutritionInformationList?: Array<ServingNutritionDto>;
}
/**
 * 
 * @export
 * @interface ProductFacetsDto
 */
export interface ProductFacetsDto {
    /**
     * 
     * @type {Array<LocalizedAttributeFacetDto>}
     * @memberof ProductFacetsDto
     */
    attributes: Array<LocalizedAttributeFacetDto>;
    /**
     * 
     * @type {Array<PropertyFacetDto>}
     * @memberof ProductFacetsDto
     */
    properties: Array<PropertyFacetDto>;
    /**
     * The parent categories of the requested category, including that category itself. In order such that the root category is the first element of the array. Empty if no specific category was requested.
     * @type {Array<CategoryDto>}
     * @memberof ProductFacetsDto
     */
    parentCategories: Array<CategoryDto>;
    /**
     * The parent category facets of the requested category, including that category itself. The order is descendent - the root category is the first element of the array. Empty if no specific category was requested.
     * @type {Array<CategoryFacetDto>}
     * @memberof ProductFacetsDto
     */
    parentCategoryFacets: Array<CategoryFacetDto>;
    /**
     * The direct child category facets of the requested category.
     * @type {Array<CategoryFacetDto>}
     * @memberof ProductFacetsDto
     */
    childCategoryFacets: Array<CategoryFacetDto>;
    /**
     * 
     * @type {PriceRangeFilterDto}
     * @memberof ProductFacetsDto
     */
    availablePriceRange: PriceRangeFilterDto;
}
/**
 * Represents a single group of products on a category browse page.
 * @export
 * @interface ProductGroupingDto
 */
export interface ProductGroupingDto {
    /**
     * 
     * @type {CategoryDto}
     * @memberof ProductGroupingDto
     */
    category: CategoryDto;
    /**
     * The count of items in this grouping, on this page.
     * @type {number}
     * @memberof ProductGroupingDto
     */
    memberCount: number;
    /**
     * The products contained in this grouping.
     * @type {Array<ProductDto>}
     * @memberof ProductGroupingDto
     */
    products: Array<ProductDto>;
}
/**
 * A single image for a product, holding paths for different sizes.
 * @export
 * @interface ProductImageDto
 */
export interface ProductImageDto {
    /**
     * The relative paths of this image (500px) as understood by image-service.
     * @type {string}
     * @memberof ProductImageDto
     */
    mediumPath?: string;
    /**
     * The relative paths of this image\'s thumbnail (200px) as understood by image-service.
     * @type {string}
     * @memberof ProductImageDto
     */
    thumbnailPath?: string;
    /**
     * The relative paths of this image\'s big version (1500px) as understood by image-service.
     * @type {string}
     * @memberof ProductImageDto
     */
    bigPath?: string;
    /**
     * Whether this image is part of a 3D image series
     * @type {boolean}
     * @memberof ProductImageDto
     */
    is3d: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductImageDto
     */
    unitAbbreviation?: string;
}
/**
 * Represents a discounted price with its validity date range.
 * @export
 * @interface ProductOfferPriceDto
 */
export interface ProductOfferPriceDto {
    /**
     * The price of the storage unit of the product when discounted. Provided as a string so that the exact value is always used.
     * @type {string}
     * @memberof ProductOfferPriceDto
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOfferPriceDto
     */
    fromDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOfferPriceDto
     */
    toDate?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductPropertyDto {
    NEW = 'NEW',
    TIEFGEKUEHLT = 'TIEFGEKUEHLT',
    GEKUEHLT = 'GEKUEHLT',
    WIEGEARTIKEL = 'WIEGEARTIKEL',
    BESTELLARTIKEL = 'BESTELLARTIKEL',
    BIO = 'BIO',
    MSC = 'MSC',
    ASC = 'ASC',
    UNSEREKOSTBARKEITEN = 'UNSERE_KOSTBARKEITEN',
    DAUERTIEFPREIS = 'DAUERTIEFPREIS'
}

/**
 * Specifies actual business filters to limit search results by.
 * @export
 * @interface ProductSearchFilterDto
 */
export interface ProductSearchFilterDto {
    /**
     * The absolute id of the category to require, with each node in the category tree separated by a pipe. The example represents the child 08 of 06, which is a child of the root category 07. Use an empty string to allow all categories.
     * @type {string}
     * @memberof ProductSearchFilterDto
     */
    categoryId?: string;
    /**
     * Whether to limit the result to products with valid offer prices
     * @type {boolean}
     * @memberof ProductSearchFilterDto
     */
    offerPricesOnly?: boolean;
    /**
     * 
     * @type {EssentialProductFilterDto}
     * @memberof ProductSearchFilterDto
     */
    essential?: EssentialProductFilterDto;
    /**
     * 
     * @type {PriceRangeFilterDto}
     * @memberof ProductSearchFilterDto
     */
    priceRange?: PriceRangeFilterDto;
    /**
     * 
     * @type {Array<ProductAttributeDto>}
     * @memberof ProductSearchFilterDto
     */
    attributes?: Array<ProductAttributeDto>;
    /**
     * 
     * @type {Array<ProductPropertyDto>}
     * @memberof ProductSearchFilterDto
     */
    properties?: Array<ProductPropertyDto>;
}
/**
 * Specifies requirements for products to be returned by a search request.
 * @export
 * @interface ProductSearchRequestDto
 */
export interface ProductSearchRequestDto {
    /**
     * The raw query string, as entered by the end user. No guarantees are made as to how it is interpreted.
     * @type {string}
     * @memberof ProductSearchRequestDto
     */
    queryString: string;
    /**
     * 
     * @type {ProductSearchFilterDto}
     * @memberof ProductSearchRequestDto
     */
    filter?: ProductSearchFilterDto;
    /**
     * 
     * @type {PageRequestDto}
     * @memberof ProductSearchRequestDto
     */
    page?: PageRequestDto;
}
/**
 * Specifies the result of a search query for products.
 * @export
 * @interface ProductSearchResultDto
 */
export interface ProductSearchResultDto {
    /**
     * 
     * @type {ProductSearchFilterDto}
     * @memberof ProductSearchResultDto
     */
    filter?: ProductSearchFilterDto;
    /**
     * The wall clock time that passed between sending the search request to the index and having received the full result, in milliseconds.
     * @type {number}
     * @memberof ProductSearchResultDto
     */
    queryDurationMs?: number;
    /**
     * The products contained in this page.
     * @type {Array<ProductDto>}
     * @memberof ProductSearchResultDto
     */
    products: Array<ProductDto>;
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof ProductSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {ProductFacetsDto}
     * @memberof ProductSearchResultDto
     */
    facets: ProductFacetsDto;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductStatusDto {
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE'
}

/**
 * Represents a unit in which a product may be purchased. Can be understood as package size.
 * @export
 * @interface ProductUnitDto
 */
export interface ProductUnitDto {
    /**
     * human-readable name of this unit
     * @type {string}
     * @memberof ProductUnitDto
     */
    name: string;
    /**
     * description to be displayed for this unit
     * @type {string}
     * @memberof ProductUnitDto
     */
    description?: string;
    /**
     * The unit size as string to display in the webshop.
     * @type {string}
     * @memberof ProductUnitDto
     */
    unitSize?: string;
    /**
     * Product-unique abbreviation of this unit
     * @type {string}
     * @memberof ProductUnitDto
     */
    abbreviation: string;
    /**
     * The conversion factor from the storage unit to this unit, as a string so that the exact value may be used.
     * @type {string}
     * @memberof ProductUnitDto
     */
    ratio: string;
    /**
     * Whether this unit may be shown to customers
     * @type {boolean}
     * @memberof ProductUnitDto
     */
    isVisible: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductUnitDto
     */
    gtins: Array<string>;
}
/**
 * 
 * @export
 * @interface ProductUnitsDto
 */
export interface ProductUnitsDto {
    /**
     * The units in which this product is stored and sold.
     * @type {Array<ProductUnitDto>}
     * @memberof ProductUnitsDto
     */
    units: Array<ProductUnitDto>;
    /**
     * Abbreviation of the default unit
     * @type {string}
     * @memberof ProductUnitsDto
     */
    defaultUnit: string;
    /**
     * Abbreviation of the storage unit
     * @type {string}
     * @memberof ProductUnitsDto
     */
    storageUnit: string;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/products+-+Produkte
 * @export
 * @interface ProductsBlockDto
 */
export interface ProductsBlockDto {
    /**
     * 
     * @type {string}
     * @memberof ProductsBlockDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsBlockDto
     */
    subtitle?: string;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof ProductsBlockDto
     */
    products: Array<ProductDto>;
    /**
     * 
     * @type {LinkDto}
     * @memberof ProductsBlockDto
     */
    headerLink?: LinkDto;
    /**
     * 
     * @type {string}
     * @memberof ProductsBlockDto
     */
    teaserImagePath?: string;
    /**
     * 
     * @type {LinkDto}
     * @memberof ProductsBlockDto
     */
    teaserLink?: LinkDto;
}
/**
 * A facet that maps a product property to the amount of associated documents and provides a localised display name.
 * @export
 * @interface PropertyFacetDto
 */
export interface PropertyFacetDto {
    /**
     * 
     * @type {ProductPropertyDto}
     * @memberof PropertyFacetDto
     */
    key: ProductPropertyDto;
    /**
     * How many products for given query have this property
     * @type {number}
     * @memberof PropertyFacetDto
     */
    resultCount: number;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/register+-+Fragment+Registrierung
 * @export
 * @interface RegisterFragmentDto
 */
export interface RegisterFragmentDto {
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof RegisterFragmentDto
     */
    sidebar: Array<BlockDto>;
    /**
     * 
     * @type {Array<BlockDto>}
     * @memberof RegisterFragmentDto
     */
    confirmation: Array<BlockDto>;
}
/**
 * 
 * @export
 * @interface ServingNutritionDto
 */
export interface ServingNutritionDto {
    /**
     * 
     * @type {boolean}
     * @memberof ServingNutritionDto
     */
    hasIntake: boolean;
    /**
     * 
     * @type {ServingNutritionHeadingDto}
     * @memberof ServingNutritionDto
     */
    header: ServingNutritionHeadingDto;
    /**
     * 
     * @type {Array<ServingNutritionFactDto>}
     * @memberof ServingNutritionDto
     */
    facts: Array<ServingNutritionFactDto>;
}
/**
 * 
 * @export
 * @interface ServingNutritionFactComponentDto
 */
export interface ServingNutritionFactComponentDto {
    /**
     * 
     * @type {string}
     * @memberof ServingNutritionFactComponentDto
     */
    typeKey: string;
    /**
     * 
     * @type {string}
     * @memberof ServingNutritionFactComponentDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ServingNutritionFactComponentDto
     */
    intakePercent?: string;
}
/**
 * 
 * @export
 * @interface ServingNutritionFactDto
 */
export interface ServingNutritionFactDto {
    /**
     * 
     * @type {string}
     * @memberof ServingNutritionFactDto
     */
    typeKey: string;
    /**
     * 
     * @type {string}
     * @memberof ServingNutritionFactDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof ServingNutritionFactDto
     */
    intakePercent?: string;
    /**
     * 
     * @type {Array<ServingNutritionFactComponentDto>}
     * @memberof ServingNutritionFactDto
     */
    components?: Array<ServingNutritionFactComponentDto>;
}
/**
 * 
 * @export
 * @interface ServingNutritionHeadingDto
 */
export interface ServingNutritionHeadingDto {
    /**
     * 
     * @type {ServingNutritionType}
     * @memberof ServingNutritionHeadingDto
     */
    type: ServingNutritionType;
    /**
     * 
     * @type {boolean}
     * @memberof ServingNutritionHeadingDto
     */
    isPrepared: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServingNutritionHeadingDto
     */
    servingDescription?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ServingNutritionType {
    ONEHUNDRED = 'ONE_HUNDRED',
    SERVING = 'SERVING'
}

/**
 * 
 * @export
 * @interface ShippingFeeDto
 */
export interface ShippingFeeDto {
    /**
     * Minimum order sum required for this fee to be applicable.
     * @type {number}
     * @memberof ShippingFeeDto
     */
    minAmount: number;
    /**
     * Fee value for this shipping fee.
     * @type {number}
     * @memberof ShippingFeeDto
     */
    value: number;
}
/**
 * Represents a shop in the store. A shop is an instance of a tenant\'s sales endpoint.
 * @export
 * @interface ShopDto
 */
export interface ShopDto {
    /**
     * 
     * @type {string}
     * @memberof ShopDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ShopDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ShopDto
     */
    tenant: string;
}
/**
 * 
 * @export
 * @interface ShopSettingsDto
 */
export interface ShopSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopSettingsDto
     */
    minOrderValue: number;
    /**
     * 
     * @type {Array<PaymentMethodDto>}
     * @memberof ShopSettingsDto
     */
    paymentMethods: Array<PaymentMethodDto>;
    /**
     * 
     * @type {Array<DeliveryMethodDto>}
     * @memberof ShopSettingsDto
     */
    deliveryMethods: Array<DeliveryMethodDto>;
    /**
     * 
     * @type {number}
     * @memberof ShopSettingsDto
     */
    deliveryDeadlineInfoInterval: number;
}
/**
 * The current state of a shopping cart.
 * @export
 * @interface ShoppingCartDto
 */
export interface ShoppingCartDto {
    /**
     * The unique id for the shopping cart. If the shopping cart is from a user, the id matches the userId.
     * @type {string}
     * @memberof ShoppingCartDto
     */
    id: string;
    /**
     * The SSO user id of the user for this cart
     * @type {string}
     * @memberof ShoppingCartDto
     */
    userId?: string;
    /**
     * 
     * @type {Array<ShoppingCartItemGroupDto>}
     * @memberof ShoppingCartDto
     */
    itemGroups: Array<ShoppingCartItemGroupDto>;
    /**
     * 
     * @type {CouponDto}
     * @memberof ShoppingCartDto
     */
    coupon?: CouponDto;
    /**
     * 
     * @type {Date}
     * @memberof ShoppingCartDto
     */
    lastModified?: Date;
}
/**
 * An item in a shopping cart. Note that only the required properties must be set for writing an item, but when receiving an item from the server, all properties will be populated. Note that only the root-level (required) properties are recognised when sending this entity to the server, any identifiers stored in entities (unit, product) will be ignored. In fact, those aren\'t supposed to be passed to the server, but rather provided as convenience in responses from the server only.
 * @export
 * @interface ShoppingCartItemDto
 */
export interface ShoppingCartItemDto {
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartItemDto
     */
    shoppingCartId?: string;
    /**
     * The Stock Keeping Unit id of the product represented by this item.
     * @type {string}
     * @memberof ShoppingCartItemDto
     */
    sku: string;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartItemDto
     */
    shopCode: string;
    /**
     * How many units of this product are in the cart.
     * @type {number}
     * @memberof ShoppingCartItemDto
     */
    amount: number;
    /**
     * The product-unique abbreviation of the unit this item is measured in.
     * @type {string}
     * @memberof ShoppingCartItemDto
     */
    unitAbbreviation: string;
    /**
     * 
     * @type {ProductUnitDto}
     * @memberof ShoppingCartItemDto
     */
    unit?: ProductUnitDto;
    /**
     * 
     * @type {ProductDto}
     * @memberof ShoppingCartItemDto
     */
    product: ProductDto;
}
/**
 * 
 * @export
 * @interface ShoppingCartItemGroupDto
 */
export interface ShoppingCartItemGroupDto {
    /**
     * 
     * @type {CategoryDto}
     * @memberof ShoppingCartItemGroupDto
     */
    category?: CategoryDto;
    /**
     * 
     * @type {Array<ShoppingCartItemDto>}
     * @memberof ShoppingCartItemGroupDto
     */
    items: Array<ShoppingCartItemDto>;
}
/**
 * 
 * @export
 * @interface ShoppingCartRequestDto
 */
export interface ShoppingCartRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartRequestDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartRequestDto
     */
    shopCode: string;
}
/**
 * A user\'s shopping list.
 * @export
 * @interface ShoppingListDto
 */
export interface ShoppingListDto {
    /**
     * The unique id of the shopping list.
     * @type {number}
     * @memberof ShoppingListDto
     */
    id: number;
    /**
     * The shopping list title.
     * @type {string}
     * @memberof ShoppingListDto
     */
    title: string;
    /**
     * 
     * @type {Array<ShoppingCartItemGroupDto>}
     * @memberof ShoppingListDto
     */
    itemGroups: Array<ShoppingCartItemGroupDto>;
}
/**
 * The shopping list item sku and unit.
 * @export
 * @interface ShoppingListItemMetadataDto
 */
export interface ShoppingListItemMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof ShoppingListItemMetadataDto
     */
    sku: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingListItemMetadataDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingListItemMetadataDto
     */
    unitAbbreviation: string;
}
/**
 * A user\'s shopping lists with product skus and units.
 * @export
 * @interface ShoppingListMetadataDto
 */
export interface ShoppingListMetadataDto {
    /**
     * The unique id of the shopping list.
     * @type {number}
     * @memberof ShoppingListMetadataDto
     */
    id: number;
    /**
     * The shopping list title.
     * @type {string}
     * @memberof ShoppingListMetadataDto
     */
    title: string;
    /**
     * 
     * @type {Array<ShoppingListItemMetadataDto>}
     * @memberof ShoppingListMetadataDto
     */
    items: Array<ShoppingListItemMetadataDto>;
}
/**
 * https://confluence.grissemann.at/display/SRGPROJ/textblock+-+Freitext
 * @export
 * @interface TextBlockDto
 */
export interface TextBlockDto {
    /**
     * Raw HTML for this block, already sanitised, should be sanitised again before usage if possible.
     * @type {string}
     * @memberof TextBlockDto
     */
    content: string;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    salutation: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    birthDate: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    assignedShopCode: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof UserDto
     */
    billingAddress?: AddressDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof UserDto
     */
    deliveryAddress?: AddressDto;
    /**
     * 
     * @type {MegacardRequestDto}
     * @memberof UserDto
     */
    megacard?: MegacardRequestDto;
}
/**
 * 
 * @export
 * @interface UserFilterDto
 */
export interface UserFilterDto {
    /**
     * 
     * @type {string}
     * @memberof UserFilterDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFilterDto
     */
    assignedShopCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserFilterDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserFilterDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserFilterDto
     */
    lastName?: string;
}
/**
 * 
 * @export
 * @interface UserRegistrationDto
 */
export interface UserRegistrationDto {
    /**
     * 
     * @type {UserDto}
     * @memberof UserRegistrationDto
     */
    model: UserDto;
    /**
     * Whether the user opted to receive a MegaCard during registration.
     * @type {boolean}
     * @memberof UserRegistrationDto
     */
    wantsMegacard: boolean;
}
/**
 * 
 * @export
 * @interface UserSubmitDto
 */
export interface UserSubmitDto {
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    salutation: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    birthDate: string;
}
/**
 * 
 * @export
 * @interface YouTubeBlockDto
 */
export interface YouTubeBlockDto {
    /**
     * 
     * @type {string}
     * @memberof YouTubeBlockDto
     */
    viewKey: string;
    /**
     * 
     * @type {string}
     * @memberof YouTubeBlockDto
     */
    caption?: string;
}

/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a new address to logged in user
         * @param {AddressDto} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserAddress(addressDto: AddressDto, options: any = {}): RequestArgs {
            // verify required parameter 'addressDto' is not null or undefined
            if (addressDto === null || addressDto === undefined) {
                throw new RequiredError('addressDto','Required parameter addressDto was null or undefined when calling addUserAddress.');
            }
            const localVarPath = `/my/address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"AddressDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addressDto !== undefined ? addressDto : {}) : (addressDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete an address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAddress(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteUserAddress.');
            }
            const localVarPath = `/my/address/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all addresses of currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserAddresses(options: any = {}): RequestArgs {
            const localVarPath = `/my/address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get specific address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAddressById(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getUserAddressById.');
            }
            const localVarPath = `/my/address/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set default billing address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultBillingAddress(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setDefaultBillingAddress.');
            }
            const localVarPath = `/my/address/default-billing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set default delivery address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultDeliveryAddress(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setDefaultDeliveryAddress.');
            }
            const localVarPath = `/my/address/default-delivery/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary edit existing address
         * @param {number} id id of the desired address
         * @param {AddressDto} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAddress(id: number, addressDto: AddressDto, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateUserAddress.');
            }
            // verify required parameter 'addressDto' is not null or undefined
            if (addressDto === null || addressDto === undefined) {
                throw new RequiredError('addressDto','Required parameter addressDto was null or undefined when calling updateUserAddress.');
            }
            const localVarPath = `/my/address/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"AddressDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addressDto !== undefined ? addressDto : {}) : (addressDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a new address to logged in user
         * @param {AddressDto} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserAddress(addressDto: AddressDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).addUserAddress(addressDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary delete an address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAddress(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).deleteUserAddress(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get all addresses of currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserAddresses(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddressDto>> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).getAllUserAddresses(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get specific address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAddressById(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).getUserAddressById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary set default billing address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultBillingAddress(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).setDefaultBillingAddress(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary set default delivery address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultDeliveryAddress(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).setDefaultDeliveryAddress(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary edit existing address
         * @param {number} id id of the desired address
         * @param {AddressDto} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAddress(id: number, addressDto: AddressDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto> {
            const localVarAxiosArgs = AddressesApiAxiosParamCreator(configuration).updateUserAddress(id, addressDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary add a new address to logged in user
         * @param {AddressDto} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserAddress(addressDto: AddressDto, options?: any) {
            return AddressesApiFp(configuration).addUserAddress(addressDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary delete an address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAddress(id: number, options?: any) {
            return AddressesApiFp(configuration).deleteUserAddress(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary get all addresses of currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserAddresses(options?: any) {
            return AddressesApiFp(configuration).getAllUserAddresses(options)(axios, basePath);
        },
        /**
         * 
         * @summary get specific address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAddressById(id: number, options?: any) {
            return AddressesApiFp(configuration).getUserAddressById(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary set default billing address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultBillingAddress(id: number, options?: any) {
            return AddressesApiFp(configuration).setDefaultBillingAddress(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary set default delivery address
         * @param {number} id id of the desired address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultDeliveryAddress(id: number, options?: any) {
            return AddressesApiFp(configuration).setDefaultDeliveryAddress(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary edit existing address
         * @param {number} id id of the desired address
         * @param {AddressDto} addressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAddress(id: number, addressDto: AddressDto, options?: any) {
            return AddressesApiFp(configuration).updateUserAddress(id, addressDto, options)(axios, basePath);
        },
    };
};

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI {
    /**
     * 
     * @summary add a new address to logged in user
     * @param {AddressDto} addressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public addUserAddress(addressDto: AddressDto, options?: any) {
        return AddressesApiFp(this.configuration).addUserAddress(addressDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary delete an address
     * @param {number} id id of the desired address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public deleteUserAddress(id: number, options?: any) {
        return AddressesApiFp(this.configuration).deleteUserAddress(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get all addresses of currently logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public getAllUserAddresses(options?: any) {
        return AddressesApiFp(this.configuration).getAllUserAddresses(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get specific address
     * @param {number} id id of the desired address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public getUserAddressById(id: number, options?: any) {
        return AddressesApiFp(this.configuration).getUserAddressById(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary set default billing address
     * @param {number} id id of the desired address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public setDefaultBillingAddress(id: number, options?: any) {
        return AddressesApiFp(this.configuration).setDefaultBillingAddress(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary set default delivery address
     * @param {number} id id of the desired address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public setDefaultDeliveryAddress(id: number, options?: any) {
        return AddressesApiFp(this.configuration).setDefaultDeliveryAddress(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary edit existing address
     * @param {number} id id of the desired address
     * @param {AddressDto} addressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public updateUserAddress(id: number, addressDto: AddressDto, options?: any) {
        return AddressesApiFp(this.configuration).updateUserAddress(id, addressDto, options)(this.axios, this.basePath);
    }

}


/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all subcategories starting from the parents.
         * @param {string} shopCode The code of the shop to target.
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubCategories(shopCode: string, hideEmpty?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getAllSubCategories.');
            }
            const localVarPath = `/shop/{shopCode}/categories/sub`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (hideEmpty !== undefined) {
                localVarQueryParameter['hideEmpty'] = hideEmpty;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all root categories
         * @param {string} shopCode The code of the shop to target
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories(shopCode: string, hideEmpty?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getRootCategories.');
            }
            const localVarPath = `/shop/{shopCode}/categories/rootCategories`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (hideEmpty !== undefined) {
                localVarQueryParameter['hideEmpty'] = hideEmpty;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of subcategories of a given category
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} baseIds The ids of the base categories to retrieve direct children of
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubCategories(shopCode: string, baseIds: Array<string>, hideEmpty?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getSubCategories.');
            }
            // verify required parameter 'baseIds' is not null or undefined
            if (baseIds === null || baseIds === undefined) {
                throw new RequiredError('baseIds','Required parameter baseIds was null or undefined when calling getSubCategories.');
            }
            const localVarPath = `/shop/{shopCode}/categories/subOf/`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (baseIds) {
                localVarQueryParameter['baseIds'] = baseIds.join(COLLECTION_FORMATS.csv);
            }

            if (hideEmpty !== undefined) {
                localVarQueryParameter['hideEmpty'] = hideEmpty;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all subcategories starting from the parents.
         * @param {string} shopCode The code of the shop to target.
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubCategories(shopCode: string, hideEmpty?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>> {
            const localVarAxiosArgs = CategoriesApiAxiosParamCreator(configuration).getAllSubCategories(shopCode, hideEmpty, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a list of all root categories
         * @param {string} shopCode The code of the shop to target
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories(shopCode: string, hideEmpty?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>> {
            const localVarAxiosArgs = CategoriesApiAxiosParamCreator(configuration).getRootCategories(shopCode, hideEmpty, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a list of subcategories of a given category
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} baseIds The ids of the base categories to retrieve direct children of
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubCategories(shopCode: string, baseIds: Array<string>, hideEmpty?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>> {
            const localVarAxiosArgs = CategoriesApiAxiosParamCreator(configuration).getSubCategories(shopCode, baseIds, hideEmpty, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get all subcategories starting from the parents.
         * @param {string} shopCode The code of the shop to target.
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubCategories(shopCode: string, hideEmpty?: boolean, options?: any) {
            return CategoriesApiFp(configuration).getAllSubCategories(shopCode, hideEmpty, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get a list of all root categories
         * @param {string} shopCode The code of the shop to target
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories(shopCode: string, hideEmpty?: boolean, options?: any) {
            return CategoriesApiFp(configuration).getRootCategories(shopCode, hideEmpty, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get a list of subcategories of a given category
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} baseIds The ids of the base categories to retrieve direct children of
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubCategories(shopCode: string, baseIds: Array<string>, hideEmpty?: boolean, options?: any) {
            return CategoriesApiFp(configuration).getSubCategories(shopCode, baseIds, hideEmpty, options)(axios, basePath);
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Get all subcategories starting from the parents.
     * @param {string} shopCode The code of the shop to target.
     * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getAllSubCategories(shopCode: string, hideEmpty?: boolean, options?: any) {
        return CategoriesApiFp(this.configuration).getAllSubCategories(shopCode, hideEmpty, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get a list of all root categories
     * @param {string} shopCode The code of the shop to target
     * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getRootCategories(shopCode: string, hideEmpty?: boolean, options?: any) {
        return CategoriesApiFp(this.configuration).getRootCategories(shopCode, hideEmpty, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get a list of subcategories of a given category
     * @param {string} shopCode The code of the shop to target
     * @param {Array<string>} baseIds The ids of the base categories to retrieve direct children of
     * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getSubCategories(shopCode: string, baseIds: Array<string>, hideEmpty?: boolean, options?: any) {
        return CategoriesApiFp(this.configuration).getSubCategories(shopCode, baseIds, hideEmpty, options)(this.axios, this.basePath);
    }

}


/**
 * CmsApi - axios parameter creator
 * @export
 */
export const CmsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve a dynamic-schema page.
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {string} webrootPath Mesh webroot path, passed via query to work around Swagger limitations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsDynPage(tenantCode: string, shopCode: string, language: string, webrootPath: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenantCode' is not null or undefined
            if (tenantCode === null || tenantCode === undefined) {
                throw new RequiredError('tenantCode','Required parameter tenantCode was null or undefined when calling getCmsDynPage.');
            }
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getCmsDynPage.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getCmsDynPage.');
            }
            // verify required parameter 'webrootPath' is not null or undefined
            if (webrootPath === null || webrootPath === undefined) {
                throw new RequiredError('webrootPath','Required parameter webrootPath was null or undefined when calling getCmsDynPage.');
            }
            const localVarPath = `/cms/{tenantCode}/{shopCode}/{language}/dynpage`
                .replace(`{${"tenantCode"}}`, encodeURIComponent(String(tenantCode)))
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (webrootPath !== undefined) {
                localVarQueryParameter['webrootPath'] = webrootPath;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the footer fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFooterFragment(tenantCode: string, shopCode: string, language: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenantCode' is not null or undefined
            if (tenantCode === null || tenantCode === undefined) {
                throw new RequiredError('tenantCode','Required parameter tenantCode was null or undefined when calling getFooterFragment.');
            }
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getFooterFragment.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getFooterFragment.');
            }
            const localVarPath = `/cms/{tenantCode}/{shopCode}/{language}/footer`
                .replace(`{${"tenantCode"}}`, encodeURIComponent(String(tenantCode)))
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the header fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeaderFragment(tenantCode: string, shopCode: string, language: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenantCode' is not null or undefined
            if (tenantCode === null || tenantCode === undefined) {
                throw new RequiredError('tenantCode','Required parameter tenantCode was null or undefined when calling getHeaderFragment.');
            }
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getHeaderFragment.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getHeaderFragment.');
            }
            const localVarPath = `/cms/{tenantCode}/{shopCode}/{language}/header`
                .replace(`{${"tenantCode"}}`, encodeURIComponent(String(tenantCode)))
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the order fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFragment(tenantCode: string, shopCode: string, language: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenantCode' is not null or undefined
            if (tenantCode === null || tenantCode === undefined) {
                throw new RequiredError('tenantCode','Required parameter tenantCode was null or undefined when calling getOrderFragment.');
            }
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getOrderFragment.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getOrderFragment.');
            }
            const localVarPath = `/cms/{tenantCode}/{shopCode}/{language}/order`
                .replace(`{${"tenantCode"}}`, encodeURIComponent(String(tenantCode)))
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the register fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisterFragment(tenantCode: string, shopCode: string, language: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenantCode' is not null or undefined
            if (tenantCode === null || tenantCode === undefined) {
                throw new RequiredError('tenantCode','Required parameter tenantCode was null or undefined when calling getRegisterFragment.');
            }
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getRegisterFragment.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling getRegisterFragment.');
            }
            const localVarPath = `/cms/{tenantCode}/{shopCode}/{language}/register`
                .replace(`{${"tenantCode"}}`, encodeURIComponent(String(tenantCode)))
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CmsApi - functional programming interface
 * @export
 */
export const CmsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve a dynamic-schema page.
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {string} webrootPath Mesh webroot path, passed via query to work around Swagger limitations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsDynPage(tenantCode: string, shopCode: string, language: string, webrootPath: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DynPageDto> {
            const localVarAxiosArgs = CmsApiAxiosParamCreator(configuration).getCmsDynPage(tenantCode, shopCode, language, webrootPath, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the footer fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFooterFragment(tenantCode: string, shopCode: string, language: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FooterFragmentDto> {
            const localVarAxiosArgs = CmsApiAxiosParamCreator(configuration).getFooterFragment(tenantCode, shopCode, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the header fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeaderFragment(tenantCode: string, shopCode: string, language: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeaderFragmentDto> {
            const localVarAxiosArgs = CmsApiAxiosParamCreator(configuration).getHeaderFragment(tenantCode, shopCode, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the order fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFragment(tenantCode: string, shopCode: string, language: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderFragmentDto> {
            const localVarAxiosArgs = CmsApiAxiosParamCreator(configuration).getOrderFragment(tenantCode, shopCode, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve the register fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisterFragment(tenantCode: string, shopCode: string, language: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterFragmentDto> {
            const localVarAxiosArgs = CmsApiAxiosParamCreator(configuration).getRegisterFragment(tenantCode, shopCode, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CmsApi - factory interface
 * @export
 */
export const CmsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Retrieve a dynamic-schema page.
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {string} webrootPath Mesh webroot path, passed via query to work around Swagger limitations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsDynPage(tenantCode: string, shopCode: string, language: string, webrootPath: string, options?: any) {
            return CmsApiFp(configuration).getCmsDynPage(tenantCode, shopCode, language, webrootPath, options)(axios, basePath);
        },
        /**
         * 
         * @summary Retrieve the footer fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFooterFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
            return CmsApiFp(configuration).getFooterFragment(tenantCode, shopCode, language, options)(axios, basePath);
        },
        /**
         * 
         * @summary Retrieve the header fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeaderFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
            return CmsApiFp(configuration).getHeaderFragment(tenantCode, shopCode, language, options)(axios, basePath);
        },
        /**
         * 
         * @summary Retrieve the order fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
            return CmsApiFp(configuration).getOrderFragment(tenantCode, shopCode, language, options)(axios, basePath);
        },
        /**
         * 
         * @summary Retrieve the register fragment
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisterFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
            return CmsApiFp(configuration).getRegisterFragment(tenantCode, shopCode, language, options)(axios, basePath);
        },
    };
};

/**
 * CmsApi - object-oriented interface
 * @export
 * @class CmsApi
 * @extends {BaseAPI}
 */
export class CmsApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve a dynamic-schema page.
     * @param {string} tenantCode 
     * @param {string} shopCode 
     * @param {string} language 
     * @param {string} webrootPath Mesh webroot path, passed via query to work around Swagger limitations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsApi
     */
    public getCmsDynPage(tenantCode: string, shopCode: string, language: string, webrootPath: string, options?: any) {
        return CmsApiFp(this.configuration).getCmsDynPage(tenantCode, shopCode, language, webrootPath, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Retrieve the footer fragment
     * @param {string} tenantCode 
     * @param {string} shopCode 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsApi
     */
    public getFooterFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
        return CmsApiFp(this.configuration).getFooterFragment(tenantCode, shopCode, language, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Retrieve the header fragment
     * @param {string} tenantCode 
     * @param {string} shopCode 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsApi
     */
    public getHeaderFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
        return CmsApiFp(this.configuration).getHeaderFragment(tenantCode, shopCode, language, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Retrieve the order fragment
     * @param {string} tenantCode 
     * @param {string} shopCode 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsApi
     */
    public getOrderFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
        return CmsApiFp(this.configuration).getOrderFragment(tenantCode, shopCode, language, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Retrieve the register fragment
     * @param {string} tenantCode 
     * @param {string} shopCode 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsApi
     */
    public getRegisterFragment(tenantCode: string, shopCode: string, language: string, options?: any) {
        return CmsApiFp(this.configuration).getRegisterFragment(tenantCode, shopCode, language, options)(this.axios, this.basePath);
    }

}


/**
 * CmsFormSubmissionApi - axios parameter creator
 * @export
 */
export const CmsFormSubmissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Subimt the provided form data. This sends out an email to the revievers that are configered in the cms
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {string} formNodePath Mesh path of the form node
         * @param {Array<FormSubmissionFieldDto>} formSubmissionFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFormData(tenantCode: string, shopCode: string, language: string, formNodePath: string, formSubmissionFieldDto: Array<FormSubmissionFieldDto>, options: any = {}): RequestArgs {
            // verify required parameter 'tenantCode' is not null or undefined
            if (tenantCode === null || tenantCode === undefined) {
                throw new RequiredError('tenantCode','Required parameter tenantCode was null or undefined when calling submitFormData.');
            }
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling submitFormData.');
            }
            // verify required parameter 'language' is not null or undefined
            if (language === null || language === undefined) {
                throw new RequiredError('language','Required parameter language was null or undefined when calling submitFormData.');
            }
            // verify required parameter 'formNodePath' is not null or undefined
            if (formNodePath === null || formNodePath === undefined) {
                throw new RequiredError('formNodePath','Required parameter formNodePath was null or undefined when calling submitFormData.');
            }
            // verify required parameter 'formSubmissionFieldDto' is not null or undefined
            if (formSubmissionFieldDto === null || formSubmissionFieldDto === undefined) {
                throw new RequiredError('formSubmissionFieldDto','Required parameter formSubmissionFieldDto was null or undefined when calling submitFormData.');
            }
            const localVarPath = `/cms/{tenantCode}/{shopCode}/{language}/form/submit`
                .replace(`{${"tenantCode"}}`, encodeURIComponent(String(tenantCode)))
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (formNodePath !== undefined) {
                localVarQueryParameter['formNodePath'] = formNodePath;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"Array&lt;FormSubmissionFieldDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(formSubmissionFieldDto !== undefined ? formSubmissionFieldDto : {}) : (formSubmissionFieldDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CmsFormSubmissionApi - functional programming interface
 * @export
 */
export const CmsFormSubmissionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Subimt the provided form data. This sends out an email to the revievers that are configered in the cms
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {string} formNodePath Mesh path of the form node
         * @param {Array<FormSubmissionFieldDto>} formSubmissionFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFormData(tenantCode: string, shopCode: string, language: string, formNodePath: string, formSubmissionFieldDto: Array<FormSubmissionFieldDto>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = CmsFormSubmissionApiAxiosParamCreator(configuration).submitFormData(tenantCode, shopCode, language, formNodePath, formSubmissionFieldDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CmsFormSubmissionApi - factory interface
 * @export
 */
export const CmsFormSubmissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Subimt the provided form data. This sends out an email to the revievers that are configered in the cms
         * @param {string} tenantCode 
         * @param {string} shopCode 
         * @param {string} language 
         * @param {string} formNodePath Mesh path of the form node
         * @param {Array<FormSubmissionFieldDto>} formSubmissionFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFormData(tenantCode: string, shopCode: string, language: string, formNodePath: string, formSubmissionFieldDto: Array<FormSubmissionFieldDto>, options?: any) {
            return CmsFormSubmissionApiFp(configuration).submitFormData(tenantCode, shopCode, language, formNodePath, formSubmissionFieldDto, options)(axios, basePath);
        },
    };
};

/**
 * CmsFormSubmissionApi - object-oriented interface
 * @export
 * @class CmsFormSubmissionApi
 * @extends {BaseAPI}
 */
export class CmsFormSubmissionApi extends BaseAPI {
    /**
     * 
     * @summary Subimt the provided form data. This sends out an email to the revievers that are configered in the cms
     * @param {string} tenantCode 
     * @param {string} shopCode 
     * @param {string} language 
     * @param {string} formNodePath Mesh path of the form node
     * @param {Array<FormSubmissionFieldDto>} formSubmissionFieldDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsFormSubmissionApi
     */
    public submitFormData(tenantCode: string, shopCode: string, language: string, formNodePath: string, formSubmissionFieldDto: Array<FormSubmissionFieldDto>, options?: any) {
        return CmsFormSubmissionApiFp(this.configuration).submitFormData(tenantCode, shopCode, language, formNodePath, formSubmissionFieldDto, options)(this.axios, this.basePath);
    }

}


/**
 * DeliverySlotsApi - axios parameter creator
 * @export
 */
export const DeliverySlotsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of available near-future delivery slots for given parameters
         * @param {string} shopCode The code of the shop to target
         * @param {DeliveryMethodDto} deliveryMethod The type of delivery
         * @param {string} countryId Country code according to ISO-3166-1
         * @param {string} postCode The post code that the delivery should happen at. Note that post codes need not always represent actual post codes, but may also represent e.g. apartments or physical stores.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDeliverySlots(shopCode: string, deliveryMethod: DeliveryMethodDto, countryId: string, postCode: string, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getAvailableDeliverySlots.');
            }
            // verify required parameter 'deliveryMethod' is not null or undefined
            if (deliveryMethod === null || deliveryMethod === undefined) {
                throw new RequiredError('deliveryMethod','Required parameter deliveryMethod was null or undefined when calling getAvailableDeliverySlots.');
            }
            // verify required parameter 'countryId' is not null or undefined
            if (countryId === null || countryId === undefined) {
                throw new RequiredError('countryId','Required parameter countryId was null or undefined when calling getAvailableDeliverySlots.');
            }
            // verify required parameter 'postCode' is not null or undefined
            if (postCode === null || postCode === undefined) {
                throw new RequiredError('postCode','Required parameter postCode was null or undefined when calling getAvailableDeliverySlots.');
            }
            const localVarPath = `/shop/{shopCode}/delivery-slots/for/{deliveryMethod}/in/{countryId}/{postCode}`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"deliveryMethod"}}`, encodeURIComponent(String(deliveryMethod)))
                .replace(`{${"countryId"}}`, encodeURIComponent(String(countryId)))
                .replace(`{${"postCode"}}`, encodeURIComponent(String(postCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliverySlotsApi - functional programming interface
 * @export
 */
export const DeliverySlotsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of available near-future delivery slots for given parameters
         * @param {string} shopCode The code of the shop to target
         * @param {DeliveryMethodDto} deliveryMethod The type of delivery
         * @param {string} countryId Country code according to ISO-3166-1
         * @param {string} postCode The post code that the delivery should happen at. Note that post codes need not always represent actual post codes, but may also represent e.g. apartments or physical stores.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDeliverySlots(shopCode: string, deliveryMethod: DeliveryMethodDto, countryId: string, postCode: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryDayDto>> {
            const localVarAxiosArgs = DeliverySlotsApiAxiosParamCreator(configuration).getAvailableDeliverySlots(shopCode, deliveryMethod, countryId, postCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DeliverySlotsApi - factory interface
 * @export
 */
export const DeliverySlotsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get a list of available near-future delivery slots for given parameters
         * @param {string} shopCode The code of the shop to target
         * @param {DeliveryMethodDto} deliveryMethod The type of delivery
         * @param {string} countryId Country code according to ISO-3166-1
         * @param {string} postCode The post code that the delivery should happen at. Note that post codes need not always represent actual post codes, but may also represent e.g. apartments or physical stores.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDeliverySlots(shopCode: string, deliveryMethod: DeliveryMethodDto, countryId: string, postCode: string, options?: any) {
            return DeliverySlotsApiFp(configuration).getAvailableDeliverySlots(shopCode, deliveryMethod, countryId, postCode, options)(axios, basePath);
        },
    };
};

/**
 * DeliverySlotsApi - object-oriented interface
 * @export
 * @class DeliverySlotsApi
 * @extends {BaseAPI}
 */
export class DeliverySlotsApi extends BaseAPI {
    /**
     * 
     * @summary Get a list of available near-future delivery slots for given parameters
     * @param {string} shopCode The code of the shop to target
     * @param {DeliveryMethodDto} deliveryMethod The type of delivery
     * @param {string} countryId Country code according to ISO-3166-1
     * @param {string} postCode The post code that the delivery should happen at. Note that post codes need not always represent actual post codes, but may also represent e.g. apartments or physical stores.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliverySlotsApi
     */
    public getAvailableDeliverySlots(shopCode: string, deliveryMethod: DeliveryMethodDto, countryId: string, postCode: string, options?: any) {
        return DeliverySlotsApiFp(this.configuration).getAvailableDeliverySlots(shopCode, deliveryMethod, countryId, postCode, options)(this.axios, this.basePath);
    }

}


/**
 * InvoicingApi - axios parameter creator
 * @export
 */
export const InvoicingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generates a invoice from the order pick response, which will be exported as XML & PDF
         * @param {PickResponseDto} pickResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processOrderPickResponse(pickResponseDto: PickResponseDto, options: any = {}): RequestArgs {
            // verify required parameter 'pickResponseDto' is not null or undefined
            if (pickResponseDto === null || pickResponseDto === undefined) {
                throw new RequiredError('pickResponseDto','Required parameter pickResponseDto was null or undefined when calling processOrderPickResponse.');
            }
            const localVarPath = `/.erp/invoicing/order-pick-response`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PickResponseDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pickResponseDto !== undefined ? pickResponseDto : {}) : (pickResponseDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicingApi - functional programming interface
 * @export
 */
export const InvoicingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generates a invoice from the order pick response, which will be exported as XML & PDF
         * @param {PickResponseDto} pickResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processOrderPickResponse(pickResponseDto: PickResponseDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = InvoicingApiAxiosParamCreator(configuration).processOrderPickResponse(pickResponseDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InvoicingApi - factory interface
 * @export
 */
export const InvoicingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Generates a invoice from the order pick response, which will be exported as XML & PDF
         * @param {PickResponseDto} pickResponseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processOrderPickResponse(pickResponseDto: PickResponseDto, options?: any) {
            return InvoicingApiFp(configuration).processOrderPickResponse(pickResponseDto, options)(axios, basePath);
        },
    };
};

/**
 * InvoicingApi - object-oriented interface
 * @export
 * @class InvoicingApi
 * @extends {BaseAPI}
 */
export class InvoicingApi extends BaseAPI {
    /**
     * 
     * @summary Generates a invoice from the order pick response, which will be exported as XML & PDF
     * @param {PickResponseDto} pickResponseDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    public processOrderPickResponse(pickResponseDto: PickResponseDto, options?: any) {
        return InvoicingApiFp(this.configuration).processOrderPickResponse(pickResponseDto, options)(this.axios, this.basePath);
    }

}


/**
 * ManageCouponsApi - axios parameter creator
 * @export
 */
export const ManageCouponsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new coupon
         * @param {CouponDto} couponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoupon(couponDto: CouponDto, options: any = {}): RequestArgs {
            // verify required parameter 'couponDto' is not null or undefined
            if (couponDto === null || couponDto === undefined) {
                throw new RequiredError('couponDto','Required parameter couponDto was null or undefined when calling addCoupon.');
            }
            const localVarPath = `/.erp/coupon`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CouponDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(couponDto !== undefined ? couponDto : {}) : (couponDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a coupon
         * @param {string} code code of the desired coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon(code: string, options: any = {}): RequestArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling deleteCoupon.');
            }
            const localVarPath = `/.erp/coupon/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get specific coupon
         * @param {string} code code of the desired coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponByCode(code: string, options: any = {}): RequestArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling getCouponByCode.');
            }
            const localVarPath = `/.erp/coupon/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a (paginated) list of all coupons
         * @param {PageRequestDto} [pageRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons(pageRequestDto?: PageRequestDto, options: any = {}): RequestArgs {
            const localVarPath = `/.erp/coupons`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageRequestDto !== undefined ? pageRequestDto : {}) : (pageRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageCouponsApi - functional programming interface
 * @export
 */
export const ManageCouponsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new coupon
         * @param {CouponDto} couponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoupon(couponDto: CouponDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ManageCouponsApiAxiosParamCreator(configuration).addCoupon(couponDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary delete a coupon
         * @param {string} code code of the desired coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon(code: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ManageCouponsApiAxiosParamCreator(configuration).deleteCoupon(code, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get specific coupon
         * @param {string} code code of the desired coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponByCode(code: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponDto> {
            const localVarAxiosArgs = ManageCouponsApiAxiosParamCreator(configuration).getCouponByCode(code, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary get a (paginated) list of all coupons
         * @param {PageRequestDto} [pageRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons(pageRequestDto?: PageRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCouponsDto> {
            const localVarAxiosArgs = ManageCouponsApiAxiosParamCreator(configuration).getCoupons(pageRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ManageCouponsApi - factory interface
 * @export
 */
export const ManageCouponsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add a new coupon
         * @param {CouponDto} couponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoupon(couponDto: CouponDto, options?: any) {
            return ManageCouponsApiFp(configuration).addCoupon(couponDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary delete a coupon
         * @param {string} code code of the desired coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon(code: string, options?: any) {
            return ManageCouponsApiFp(configuration).deleteCoupon(code, options)(axios, basePath);
        },
        /**
         * 
         * @summary get specific coupon
         * @param {string} code code of the desired coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponByCode(code: string, options?: any) {
            return ManageCouponsApiFp(configuration).getCouponByCode(code, options)(axios, basePath);
        },
        /**
         * 
         * @summary get a (paginated) list of all coupons
         * @param {PageRequestDto} [pageRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons(pageRequestDto?: PageRequestDto, options?: any) {
            return ManageCouponsApiFp(configuration).getCoupons(pageRequestDto, options)(axios, basePath);
        },
    };
};

/**
 * ManageCouponsApi - object-oriented interface
 * @export
 * @class ManageCouponsApi
 * @extends {BaseAPI}
 */
export class ManageCouponsApi extends BaseAPI {
    /**
     * 
     * @summary Add a new coupon
     * @param {CouponDto} couponDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCouponsApi
     */
    public addCoupon(couponDto: CouponDto, options?: any) {
        return ManageCouponsApiFp(this.configuration).addCoupon(couponDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary delete a coupon
     * @param {string} code code of the desired coupon
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCouponsApi
     */
    public deleteCoupon(code: string, options?: any) {
        return ManageCouponsApiFp(this.configuration).deleteCoupon(code, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get specific coupon
     * @param {string} code code of the desired coupon
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCouponsApi
     */
    public getCouponByCode(code: string, options?: any) {
        return ManageCouponsApiFp(this.configuration).getCouponByCode(code, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary get a (paginated) list of all coupons
     * @param {PageRequestDto} [pageRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCouponsApi
     */
    public getCoupons(pageRequestDto?: PageRequestDto, options?: any) {
        return ManageCouponsApiFp(this.configuration).getCoupons(pageRequestDto, options)(this.axios, this.basePath);
    }

}


/**
 * ManagementApi - axios parameter creator
 * @export
 */
export const ManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Trigger the order export of the given order.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderById(orderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling exportOrderById.');
            }
            const localVarPath = `/.internal/manage/order/{orderId}/force-export`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get (paginated) list of all orders.
         * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders(managementOrderRequestDto?: ManagementOrderRequestDto, options: any = {}): RequestArgs {
            const localVarPath = `/.internal/manage/orders`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ManagementOrderRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(managementOrderRequestDto !== undefined ? managementOrderRequestDto : {}) : (managementOrderRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get (paginated) list of all registered users with their data.
         * @param {ManagementUserRequestDto} [managementUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(managementUserRequestDto?: ManagementUserRequestDto, options: any = {}): RequestArgs {
            const localVarPath = `/.internal/manage/users`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ManagementUserRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(managementUserRequestDto !== undefined ? managementUserRequestDto : {}) : (managementUserRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the invoice pdf (base64 string) of the given order.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdfByOrderId(orderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getInvoicePdfByOrderId.');
            }
            const localVarPath = `/.internal/manage/order/{orderId}/invoice-pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get order by orderId.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(orderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getOrderById.');
            }
            const localVarPath = `/.internal/manage/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get (paginated) list of all orders from user with userId.
         * @param {string} userId The user id
         * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersByUserId(userId: string, managementOrderRequestDto?: ManagementOrderRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getOrdersByUserId.');
            }
            const localVarPath = `/.internal/manage/user/{userId}/orders`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ManagementOrderRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(managementOrderRequestDto !== undefined ? managementOrderRequestDto : {}) : (managementOrderRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all user data by user id.
         * @param {string} userId The user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUserId(userId: string, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserByUserId.');
            }
            const localVarPath = `/.internal/manage/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the given user by user id.
         * @param {string} userId The user id
         * @param {ManagementUserDto} managementUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserByUserId(userId: string, managementUserDto: ManagementUserDto, options: any = {}): RequestArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling updateUserByUserId.');
            }
            // verify required parameter 'managementUserDto' is not null or undefined
            if (managementUserDto === null || managementUserDto === undefined) {
                throw new RequiredError('managementUserDto','Required parameter managementUserDto was null or undefined when calling updateUserByUserId.');
            }
            const localVarPath = `/.internal/manage/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ManagementUserDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(managementUserDto !== undefined ? managementUserDto : {}) : (managementUserDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagementApi - functional programming interface
 * @export
 */
export const ManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Trigger the order export of the given order.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderById(orderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).exportOrderById(orderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get (paginated) list of all orders.
         * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders(managementOrderRequestDto?: ManagementOrderRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrdersDto> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).getAllOrders(managementOrderRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get (paginated) list of all registered users with their data.
         * @param {ManagementUserRequestDto} [managementUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(managementUserRequestDto?: ManagementUserRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedManagementUsersDto> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).getAllUsers(managementUserRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets the invoice pdf (base64 string) of the given order.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdfByOrderId(orderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).getInvoicePdfByOrderId(orderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get order by orderId.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(orderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).getOrderById(orderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get (paginated) list of all orders from user with userId.
         * @param {string} userId The user id
         * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersByUserId(userId: string, managementOrderRequestDto?: ManagementOrderRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrdersDto> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).getOrdersByUserId(userId, managementOrderRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all user data by user id.
         * @param {string} userId The user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUserId(userId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManagementUserDto> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).getUserByUserId(userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update the given user by user id.
         * @param {string} userId The user id
         * @param {ManagementUserDto} managementUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserByUserId(userId: string, managementUserDto: ManagementUserDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManagementUserDto> {
            const localVarAxiosArgs = ManagementApiAxiosParamCreator(configuration).updateUserByUserId(userId, managementUserDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ManagementApi - factory interface
 * @export
 */
export const ManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Trigger the order export of the given order.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderById(orderId: string, options?: any) {
            return ManagementApiFp(configuration).exportOrderById(orderId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get (paginated) list of all orders.
         * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders(managementOrderRequestDto?: ManagementOrderRequestDto, options?: any) {
            return ManagementApiFp(configuration).getAllOrders(managementOrderRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get (paginated) list of all registered users with their data.
         * @param {ManagementUserRequestDto} [managementUserRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(managementUserRequestDto?: ManagementUserRequestDto, options?: any) {
            return ManagementApiFp(configuration).getAllUsers(managementUserRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Gets the invoice pdf (base64 string) of the given order.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdfByOrderId(orderId: string, options?: any) {
            return ManagementApiFp(configuration).getInvoicePdfByOrderId(orderId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get order by orderId.
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(orderId: string, options?: any) {
            return ManagementApiFp(configuration).getOrderById(orderId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get (paginated) list of all orders from user with userId.
         * @param {string} userId The user id
         * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersByUserId(userId: string, managementOrderRequestDto?: ManagementOrderRequestDto, options?: any) {
            return ManagementApiFp(configuration).getOrdersByUserId(userId, managementOrderRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get all user data by user id.
         * @param {string} userId The user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUserId(userId: string, options?: any) {
            return ManagementApiFp(configuration).getUserByUserId(userId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update the given user by user id.
         * @param {string} userId The user id
         * @param {ManagementUserDto} managementUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserByUserId(userId: string, managementUserDto: ManagementUserDto, options?: any) {
            return ManagementApiFp(configuration).updateUserByUserId(userId, managementUserDto, options)(axios, basePath);
        },
    };
};

/**
 * ManagementApi - object-oriented interface
 * @export
 * @class ManagementApi
 * @extends {BaseAPI}
 */
export class ManagementApi extends BaseAPI {
    /**
     * 
     * @summary Trigger the order export of the given order.
     * @param {string} orderId The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public exportOrderById(orderId: string, options?: any) {
        return ManagementApiFp(this.configuration).exportOrderById(orderId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get (paginated) list of all orders.
     * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getAllOrders(managementOrderRequestDto?: ManagementOrderRequestDto, options?: any) {
        return ManagementApiFp(this.configuration).getAllOrders(managementOrderRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get (paginated) list of all registered users with their data.
     * @param {ManagementUserRequestDto} [managementUserRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getAllUsers(managementUserRequestDto?: ManagementUserRequestDto, options?: any) {
        return ManagementApiFp(this.configuration).getAllUsers(managementUserRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Gets the invoice pdf (base64 string) of the given order.
     * @param {string} orderId The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getInvoicePdfByOrderId(orderId: string, options?: any) {
        return ManagementApiFp(this.configuration).getInvoicePdfByOrderId(orderId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get order by orderId.
     * @param {string} orderId The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getOrderById(orderId: string, options?: any) {
        return ManagementApiFp(this.configuration).getOrderById(orderId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get (paginated) list of all orders from user with userId.
     * @param {string} userId The user id
     * @param {ManagementOrderRequestDto} [managementOrderRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getOrdersByUserId(userId: string, managementOrderRequestDto?: ManagementOrderRequestDto, options?: any) {
        return ManagementApiFp(this.configuration).getOrdersByUserId(userId, managementOrderRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get all user data by user id.
     * @param {string} userId The user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getUserByUserId(userId: string, options?: any) {
        return ManagementApiFp(this.configuration).getUserByUserId(userId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update the given user by user id.
     * @param {string} userId The user id
     * @param {ManagementUserDto} managementUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public updateUserByUserId(userId: string, managementUserDto: ManagementUserDto, options?: any) {
        return ManagementApiFp(this.configuration).updateUserByUserId(userId, managementUserDto, options)(this.axios, this.basePath);
    }

}


/**
 * MegacardApi - axios parameter creator
 * @export
 */
export const MegacardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Connect a Megacard to the current account
         * @param {MegacardRequestDto} megacardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectMegacard(megacardRequestDto: MegacardRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'megacardRequestDto' is not null or undefined
            if (megacardRequestDto === null || megacardRequestDto === undefined) {
                throw new RequiredError('megacardRequestDto','Required parameter megacardRequestDto was null or undefined when calling connectMegacard.');
            }
            const localVarPath = `/my/megacard/connect`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"MegacardRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(megacardRequestDto !== undefined ? megacardRequestDto : {}) : (megacardRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview Megacard information for pre-filling of address data
         * @param {MegacardRequestDto} megacardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMegacardData(megacardRequestDto: MegacardRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'megacardRequestDto' is not null or undefined
            if (megacardRequestDto === null || megacardRequestDto === undefined) {
                throw new RequiredError('megacardRequestDto','Required parameter megacardRequestDto was null or undefined when calling previewMegacardData.');
            }
            const localVarPath = `/my/megacard/preview`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"MegacardRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(megacardRequestDto !== undefined ? megacardRequestDto : {}) : (megacardRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MegacardApi - functional programming interface
 * @export
 */
export const MegacardApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Connect a Megacard to the current account
         * @param {MegacardRequestDto} megacardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectMegacard(megacardRequestDto: MegacardRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = MegacardApiAxiosParamCreator(configuration).connectMegacard(megacardRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Preview Megacard information for pre-filling of address data
         * @param {MegacardRequestDto} megacardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMegacardData(megacardRequestDto: MegacardRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto> {
            const localVarAxiosArgs = MegacardApiAxiosParamCreator(configuration).previewMegacardData(megacardRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MegacardApi - factory interface
 * @export
 */
export const MegacardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Connect a Megacard to the current account
         * @param {MegacardRequestDto} megacardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectMegacard(megacardRequestDto: MegacardRequestDto, options?: any) {
            return MegacardApiFp(configuration).connectMegacard(megacardRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Preview Megacard information for pre-filling of address data
         * @param {MegacardRequestDto} megacardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMegacardData(megacardRequestDto: MegacardRequestDto, options?: any) {
            return MegacardApiFp(configuration).previewMegacardData(megacardRequestDto, options)(axios, basePath);
        },
    };
};

/**
 * MegacardApi - object-oriented interface
 * @export
 * @class MegacardApi
 * @extends {BaseAPI}
 */
export class MegacardApi extends BaseAPI {
    /**
     * 
     * @summary Connect a Megacard to the current account
     * @param {MegacardRequestDto} megacardRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MegacardApi
     */
    public connectMegacard(megacardRequestDto: MegacardRequestDto, options?: any) {
        return MegacardApiFp(this.configuration).connectMegacard(megacardRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Preview Megacard information for pre-filling of address data
     * @param {MegacardRequestDto} megacardRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MegacardApi
     */
    public previewMegacardData(megacardRequestDto: MegacardRequestDto, options?: any) {
        return MegacardApiFp(this.configuration).previewMegacardData(megacardRequestDto, options)(this.axios, this.basePath);
    }

}


/**
 * OrderConfirmationApi - axios parameter creator
 * @export
 */
export const OrderConfirmationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderId The Id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderConfirmationPdf(orderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getOrderConfirmationPdf.');
            }
            const localVarPath = `/my/order/{orderId}/confirmation-pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderConfirmationApi - functional programming interface
 * @export
 */
export const OrderConfirmationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orderId The Id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderConfirmationPdf(orderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = OrderConfirmationApiAxiosParamCreator(configuration).getOrderConfirmationPdf(orderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrderConfirmationApi - factory interface
 * @export
 */
export const OrderConfirmationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} orderId The Id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderConfirmationPdf(orderId: string, options?: any) {
            return OrderConfirmationApiFp(configuration).getOrderConfirmationPdf(orderId, options)(axios, basePath);
        },
    };
};

/**
 * OrderConfirmationApi - object-oriented interface
 * @export
 * @class OrderConfirmationApi
 * @extends {BaseAPI}
 */
export class OrderConfirmationApi extends BaseAPI {
    /**
     * 
     * @param {string} orderId The Id of the order to request the confirmation PDF for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderConfirmationApi
     */
    public getOrderConfirmationPdf(orderId: string, options?: any) {
        return OrderConfirmationApiFp(this.configuration).getOrderConfirmationPdf(orderId, options)(this.axios, this.basePath);
    }

}


/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get order by id
         * @param {string} shopCode Code of the shop to request order from
         * @param {string} orderId The Id of the order to request the details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByIdAndShopCode(shopCode: string, orderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getOrderByIdAndShopCode.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getOrderByIdAndShopCode.');
            }
            const localVarPath = `/shop/{shopCode}/order/{orderId}`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an order of a user
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrderById(orderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getUserOrderById.');
            }
            const localVarPath = `/my/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get (paginated) list of orders of a user
         * @param {PageRequestDto} [pageRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrders(pageRequestDto?: PageRequestDto, options: any = {}): RequestArgs {
            const localVarPath = `/my/orders`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PageRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(pageRequestDto !== undefined ? pageRequestDto : {}) : (pageRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pre-submit an order, storing it in the database and returning a URL for the customer to pay it.
         * @param {string} shopCode Code of the shop to submit for
         * @param {OrderSubmitDto} orderSubmitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preSubmitOrder(shopCode: string, orderSubmitDto: OrderSubmitDto, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling preSubmitOrder.');
            }
            // verify required parameter 'orderSubmitDto' is not null or undefined
            if (orderSubmitDto === null || orderSubmitDto === undefined) {
                throw new RequiredError('orderSubmitDto','Required parameter orderSubmitDto was null or undefined when calling preSubmitOrder.');
            }
            const localVarPath = `/shop/{shopCode}/order/pre-submit`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"OrderSubmitDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(orderSubmitDto !== undefined ? orderSubmitDto : {}) : (orderSubmitDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Callback for Viveum to resourcePath for status report. Called via user browser, so need to redirect to frontend.
         * @param {string} shopCode Code of the shop to submit for
         * @param {string} orderId Order id for reference
         * @param {string} id id of transaction for reference
         * @param {string} resourcePath resourcePath of transaction, used to retrieve status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectOrderAfterPayment(shopCode: string, orderId: string, id: string, resourcePath: string, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling redirectOrderAfterPayment.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling redirectOrderAfterPayment.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling redirectOrderAfterPayment.');
            }
            // verify required parameter 'resourcePath' is not null or undefined
            if (resourcePath === null || resourcePath === undefined) {
                throw new RequiredError('resourcePath','Required parameter resourcePath was null or undefined when calling redirectOrderAfterPayment.');
            }
            const localVarPath = `/shop/{shopCode}/order/{orderId}/payment/response`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (resourcePath !== undefined) {
                localVarQueryParameter['resourcePath'] = resourcePath;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a payment session with the payment provider and returns the URL that should be used by the frontend to forward to the payment page for this order
         * @param {string} shopCode Code of the shop to submit for
         * @param {string} orderId The Id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPayment(shopCode: string, orderId: string, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling startPayment.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling startPayment.');
            }
            const localVarPath = `/shop/{shopCode}/order/{orderId}/start-payment`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get order by id
         * @param {string} shopCode Code of the shop to request order from
         * @param {string} orderId The Id of the order to request the details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByIdAndShopCode(shopCode: string, orderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).getOrderByIdAndShopCode(shopCode, orderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get an order of a user
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrderById(orderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).getUserOrderById(orderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get (paginated) list of orders of a user
         * @param {PageRequestDto} [pageRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrders(pageRequestDto?: PageRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedOrdersDto> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).getUserOrders(pageRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Pre-submit an order, storing it in the database and returning a URL for the customer to pay it.
         * @param {string} shopCode Code of the shop to submit for
         * @param {OrderSubmitDto} orderSubmitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preSubmitOrder(shopCode: string, orderSubmitDto: OrderSubmitDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).preSubmitOrder(shopCode, orderSubmitDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Callback for Viveum to resourcePath for status report. Called via user browser, so need to redirect to frontend.
         * @param {string} shopCode Code of the shop to submit for
         * @param {string} orderId Order id for reference
         * @param {string} id id of transaction for reference
         * @param {string} resourcePath resourcePath of transaction, used to retrieve status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectOrderAfterPayment(shopCode: string, orderId: string, id: string, resourcePath: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).redirectOrderAfterPayment(shopCode, orderId, id, resourcePath, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Creates a payment session with the payment provider and returns the URL that should be used by the frontend to forward to the payment page for this order
         * @param {string} shopCode Code of the shop to submit for
         * @param {string} orderId The Id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPayment(shopCode: string, orderId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentStartDto> {
            const localVarAxiosArgs = OrdersApiAxiosParamCreator(configuration).startPayment(shopCode, orderId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get order by id
         * @param {string} shopCode Code of the shop to request order from
         * @param {string} orderId The Id of the order to request the details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByIdAndShopCode(shopCode: string, orderId: string, options?: any) {
            return OrdersApiFp(configuration).getOrderByIdAndShopCode(shopCode, orderId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get an order of a user
         * @param {string} orderId The order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrderById(orderId: string, options?: any) {
            return OrdersApiFp(configuration).getUserOrderById(orderId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get (paginated) list of orders of a user
         * @param {PageRequestDto} [pageRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrders(pageRequestDto?: PageRequestDto, options?: any) {
            return OrdersApiFp(configuration).getUserOrders(pageRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Pre-submit an order, storing it in the database and returning a URL for the customer to pay it.
         * @param {string} shopCode Code of the shop to submit for
         * @param {OrderSubmitDto} orderSubmitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preSubmitOrder(shopCode: string, orderSubmitDto: OrderSubmitDto, options?: any) {
            return OrdersApiFp(configuration).preSubmitOrder(shopCode, orderSubmitDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Callback for Viveum to resourcePath for status report. Called via user browser, so need to redirect to frontend.
         * @param {string} shopCode Code of the shop to submit for
         * @param {string} orderId Order id for reference
         * @param {string} id id of transaction for reference
         * @param {string} resourcePath resourcePath of transaction, used to retrieve status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectOrderAfterPayment(shopCode: string, orderId: string, id: string, resourcePath: string, options?: any) {
            return OrdersApiFp(configuration).redirectOrderAfterPayment(shopCode, orderId, id, resourcePath, options)(axios, basePath);
        },
        /**
         * 
         * @summary Creates a payment session with the payment provider and returns the URL that should be used by the frontend to forward to the payment page for this order
         * @param {string} shopCode Code of the shop to submit for
         * @param {string} orderId The Id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPayment(shopCode: string, orderId: string, options?: any) {
            return OrdersApiFp(configuration).startPayment(shopCode, orderId, options)(axios, basePath);
        },
    };
};

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * 
     * @summary Get order by id
     * @param {string} shopCode Code of the shop to request order from
     * @param {string} orderId The Id of the order to request the details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getOrderByIdAndShopCode(shopCode: string, orderId: string, options?: any) {
        return OrdersApiFp(this.configuration).getOrderByIdAndShopCode(shopCode, orderId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get an order of a user
     * @param {string} orderId The order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getUserOrderById(orderId: string, options?: any) {
        return OrdersApiFp(this.configuration).getUserOrderById(orderId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get (paginated) list of orders of a user
     * @param {PageRequestDto} [pageRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public getUserOrders(pageRequestDto?: PageRequestDto, options?: any) {
        return OrdersApiFp(this.configuration).getUserOrders(pageRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Pre-submit an order, storing it in the database and returning a URL for the customer to pay it.
     * @param {string} shopCode Code of the shop to submit for
     * @param {OrderSubmitDto} orderSubmitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public preSubmitOrder(shopCode: string, orderSubmitDto: OrderSubmitDto, options?: any) {
        return OrdersApiFp(this.configuration).preSubmitOrder(shopCode, orderSubmitDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Callback for Viveum to resourcePath for status report. Called via user browser, so need to redirect to frontend.
     * @param {string} shopCode Code of the shop to submit for
     * @param {string} orderId Order id for reference
     * @param {string} id id of transaction for reference
     * @param {string} resourcePath resourcePath of transaction, used to retrieve status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public redirectOrderAfterPayment(shopCode: string, orderId: string, id: string, resourcePath: string, options?: any) {
        return OrdersApiFp(this.configuration).redirectOrderAfterPayment(shopCode, orderId, id, resourcePath, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Creates a payment session with the payment provider and returns the URL that should be used by the frontend to forward to the payment page for this order
     * @param {string} shopCode Code of the shop to submit for
     * @param {string} orderId The Id of the order to request the confirmation PDF for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public startPayment(shopCode: string, orderId: string, options?: any) {
        return OrdersApiFp(this.configuration).startPayment(shopCode, orderId, options)(this.axios, this.basePath);
    }

}


/**
 * ProductSearchApi - axios parameter creator
 * @export
 */
export const ProductSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Browse a single page in a category
         * @param {string} shopCode The code of the shop to target
         * @param {BrowseRequestDto} browseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCategoryPage(shopCode: string, browseRequestDto: BrowseRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling browseCategoryPage.');
            }
            // verify required parameter 'browseRequestDto' is not null or undefined
            if (browseRequestDto === null || browseRequestDto === undefined) {
                throw new RequiredError('browseRequestDto','Required parameter browseRequestDto was null or undefined when calling browseCategoryPage.');
            }
            const localVarPath = `/shop/{shopCode}/categories/browse`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuthOptional", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"BrowseRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(browseRequestDto !== undefined ? browseRequestDto : {}) : (browseRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shows a page of products that are mentioned in given customer\'s essence list.
         * @summary Browse a page of essential products
         * @param {string} shopCode The code of the shop to target
         * @param {BrowseRequestDto} browseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseEssentialProducts(shopCode: string, browseRequestDto: BrowseRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling browseEssentialProducts.');
            }
            // verify required parameter 'browseRequestDto' is not null or undefined
            if (browseRequestDto === null || browseRequestDto === undefined) {
                throw new RequiredError('browseRequestDto','Required parameter browseRequestDto was null or undefined when calling browseEssentialProducts.');
            }
            const localVarPath = `/shop/{shopCode}/essential-products/browse`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuthOptional", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"BrowseRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(browseRequestDto !== undefined ? browseRequestDto : {}) : (browseRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Autocomplete product names
         * @param {string} shopCode The code of the shop to target
         * @param {ProductCompletionRequestDto} productCompletionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProductName(shopCode: string, productCompletionRequestDto: ProductCompletionRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling completeProductName.');
            }
            // verify required parameter 'productCompletionRequestDto' is not null or undefined
            if (productCompletionRequestDto === null || productCompletionRequestDto === undefined) {
                throw new RequiredError('productCompletionRequestDto','Required parameter productCompletionRequestDto was null or undefined when calling completeProductName.');
            }
            const localVarPath = `/shop/{shopCode}/products/complete`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuthOptional", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ProductCompletionRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productCompletionRequestDto !== undefined ? productCompletionRequestDto : {}) : (productCompletionRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {ProductSearchRequestDto} productSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProducts(shopCode: string, productSearchRequestDto: ProductSearchRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling searchProducts.');
            }
            // verify required parameter 'productSearchRequestDto' is not null or undefined
            if (productSearchRequestDto === null || productSearchRequestDto === undefined) {
                throw new RequiredError('productSearchRequestDto','Required parameter productSearchRequestDto was null or undefined when calling searchProducts.');
            }
            const localVarPath = `/shop/{shopCode}/products/search`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuthOptional", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ProductSearchRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(productSearchRequestDto !== undefined ? productSearchRequestDto : {}) : (productSearchRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSearchApi - functional programming interface
 * @export
 */
export const ProductSearchApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Browse a single page in a category
         * @param {string} shopCode The code of the shop to target
         * @param {BrowseRequestDto} browseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCategoryPage(shopCode: string, browseRequestDto: BrowseRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupedProductsDto> {
            const localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).browseCategoryPage(shopCode, browseRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Shows a page of products that are mentioned in given customer\'s essence list.
         * @summary Browse a page of essential products
         * @param {string} shopCode The code of the shop to target
         * @param {BrowseRequestDto} browseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseEssentialProducts(shopCode: string, browseRequestDto: BrowseRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupedProductsDto> {
            const localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).browseEssentialProducts(shopCode, browseRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Autocomplete product names
         * @param {string} shopCode The code of the shop to target
         * @param {ProductCompletionRequestDto} productCompletionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProductName(shopCode: string, productCompletionRequestDto: ProductCompletionRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCompletionResponseDto> {
            const localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).completeProductName(shopCode, productCompletionRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Search for a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {ProductSearchRequestDto} productSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProducts(shopCode: string, productSearchRequestDto: ProductSearchRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSearchResultDto> {
            const localVarAxiosArgs = ProductSearchApiAxiosParamCreator(configuration).searchProducts(shopCode, productSearchRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductSearchApi - factory interface
 * @export
 */
export const ProductSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Browse a single page in a category
         * @param {string} shopCode The code of the shop to target
         * @param {BrowseRequestDto} browseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCategoryPage(shopCode: string, browseRequestDto: BrowseRequestDto, options?: any) {
            return ProductSearchApiFp(configuration).browseCategoryPage(shopCode, browseRequestDto, options)(axios, basePath);
        },
        /**
         * Shows a page of products that are mentioned in given customer\'s essence list.
         * @summary Browse a page of essential products
         * @param {string} shopCode The code of the shop to target
         * @param {BrowseRequestDto} browseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseEssentialProducts(shopCode: string, browseRequestDto: BrowseRequestDto, options?: any) {
            return ProductSearchApiFp(configuration).browseEssentialProducts(shopCode, browseRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Autocomplete product names
         * @param {string} shopCode The code of the shop to target
         * @param {ProductCompletionRequestDto} productCompletionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProductName(shopCode: string, productCompletionRequestDto: ProductCompletionRequestDto, options?: any) {
            return ProductSearchApiFp(configuration).completeProductName(shopCode, productCompletionRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Search for a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {ProductSearchRequestDto} productSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProducts(shopCode: string, productSearchRequestDto: ProductSearchRequestDto, options?: any) {
            return ProductSearchApiFp(configuration).searchProducts(shopCode, productSearchRequestDto, options)(axios, basePath);
        },
    };
};

/**
 * ProductSearchApi - object-oriented interface
 * @export
 * @class ProductSearchApi
 * @extends {BaseAPI}
 */
export class ProductSearchApi extends BaseAPI {
    /**
     * 
     * @summary Browse a single page in a category
     * @param {string} shopCode The code of the shop to target
     * @param {BrowseRequestDto} browseRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public browseCategoryPage(shopCode: string, browseRequestDto: BrowseRequestDto, options?: any) {
        return ProductSearchApiFp(this.configuration).browseCategoryPage(shopCode, browseRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * Shows a page of products that are mentioned in given customer\'s essence list.
     * @summary Browse a page of essential products
     * @param {string} shopCode The code of the shop to target
     * @param {BrowseRequestDto} browseRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public browseEssentialProducts(shopCode: string, browseRequestDto: BrowseRequestDto, options?: any) {
        return ProductSearchApiFp(this.configuration).browseEssentialProducts(shopCode, browseRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Autocomplete product names
     * @param {string} shopCode The code of the shop to target
     * @param {ProductCompletionRequestDto} productCompletionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public completeProductName(shopCode: string, productCompletionRequestDto: ProductCompletionRequestDto, options?: any) {
        return ProductSearchApiFp(this.configuration).completeProductName(shopCode, productCompletionRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Search for a list of products
     * @param {string} shopCode The code of the shop to target
     * @param {ProductSearchRequestDto} productSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public searchProducts(shopCode: string, productSearchRequestDto: ProductSearchRequestDto, options?: any) {
        return ProductSearchApiFp(this.configuration).searchProducts(shopCode, productSearchRequestDto, options)(this.axios, this.basePath);
    }

}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Show details about a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} sku The SKU ids of the products to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupedProducts(shopCode: string, sku: Array<string>, showInactive?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling findGroupedProducts.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling findGroupedProducts.');
            }
            const localVarPath = `/shop/{shopCode}/products/grouped`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuthOptional", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (sku) {
                localVarQueryParameter['sku'] = sku;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show details about a single product
         * @param {string} shopCode The code of the shop to target
         * @param {string} sku The SKU id of the product to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySku(shopCode: string, sku: string, showInactive?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getProductBySku.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getProductBySku.');
            }
            const localVarPath = `/shop/{shopCode}/products/{sku}`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuthOptional", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show details about a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} sku The SKU ids of the products to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySkuBatch(shopCode: string, sku: Array<string>, showInactive?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getProductBySkuBatch.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getProductBySkuBatch.');
            }
            const localVarPath = `/shop/{shopCode}/products/skuBatch`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuthOptional", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (sku) {
                localVarQueryParameter['sku'] = sku;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Show details about a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} sku The SKU ids of the products to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupedProducts(shopCode: string, sku: Array<string>, showInactive?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupedProductsDto> {
            const localVarAxiosArgs = ProductsApiAxiosParamCreator(configuration).findGroupedProducts(shopCode, sku, showInactive, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Show details about a single product
         * @param {string} shopCode The code of the shop to target
         * @param {string} sku The SKU id of the product to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySku(shopCode: string, sku: string, showInactive?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDto> {
            const localVarAxiosArgs = ProductsApiAxiosParamCreator(configuration).getProductBySku(shopCode, sku, showInactive, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Show details about a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} sku The SKU ids of the products to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySkuBatch(shopCode: string, sku: Array<string>, showInactive?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>> {
            const localVarAxiosArgs = ProductsApiAxiosParamCreator(configuration).getProductBySkuBatch(shopCode, sku, showInactive, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Show details about a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} sku The SKU ids of the products to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupedProducts(shopCode: string, sku: Array<string>, showInactive?: boolean, options?: any) {
            return ProductsApiFp(configuration).findGroupedProducts(shopCode, sku, showInactive, options)(axios, basePath);
        },
        /**
         * 
         * @summary Show details about a single product
         * @param {string} shopCode The code of the shop to target
         * @param {string} sku The SKU id of the product to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySku(shopCode: string, sku: string, showInactive?: boolean, options?: any) {
            return ProductsApiFp(configuration).getProductBySku(shopCode, sku, showInactive, options)(axios, basePath);
        },
        /**
         * 
         * @summary Show details about a list of products
         * @param {string} shopCode The code of the shop to target
         * @param {Array<string>} sku The SKU ids of the products to target
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySkuBatch(shopCode: string, sku: Array<string>, showInactive?: boolean, options?: any) {
            return ProductsApiFp(configuration).getProductBySkuBatch(shopCode, sku, showInactive, options)(axios, basePath);
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary Show details about a list of products
     * @param {string} shopCode The code of the shop to target
     * @param {Array<string>} sku The SKU ids of the products to target
     * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public findGroupedProducts(shopCode: string, sku: Array<string>, showInactive?: boolean, options?: any) {
        return ProductsApiFp(this.configuration).findGroupedProducts(shopCode, sku, showInactive, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Show details about a single product
     * @param {string} shopCode The code of the shop to target
     * @param {string} sku The SKU id of the product to target
     * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductBySku(shopCode: string, sku: string, showInactive?: boolean, options?: any) {
        return ProductsApiFp(this.configuration).getProductBySku(shopCode, sku, showInactive, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Show details about a list of products
     * @param {string} shopCode The code of the shop to target
     * @param {Array<string>} sku The SKU ids of the products to target
     * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductBySkuBatch(shopCode: string, sku: Array<string>, showInactive?: boolean, options?: any) {
        return ProductsApiFp(this.configuration).getProductBySkuBatch(shopCode, sku, showInactive, options)(this.axios, this.basePath);
    }

}


/**
 * ShoppingCartsApi - axios parameter creator
 * @export
 */
export const ShoppingCartsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add items to your shopping cart or override existing ones. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
         * @summary Add all items to your shopping cart or override existing ones.
         * @param {Array<ShoppingCartItemDto>} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllItemsToShoppingCart(shoppingCartItemDto: Array<ShoppingCartItemDto>, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingCartItemDto' is not null or undefined
            if (shoppingCartItemDto === null || shoppingCartItemDto === undefined) {
                throw new RequiredError('shoppingCartItemDto','Required parameter shoppingCartItemDto was null or undefined when calling addAllItemsToShoppingCart.');
            }
            const localVarPath = `/shopping-cart/addAll`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"Array&lt;ShoppingCartItemDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingCartItemDto !== undefined ? shoppingCartItemDto : {}) : (shoppingCartItemDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an coupon to your shopping cart or override the exsiting one.
         * @summary Add a coupon to your shopping cart or override the existing one and return the added coupon.
         * @param {string} couponCode The coupon code to be added to the shopping cart.
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponToShoppingCart(couponCode: string, shopCode?: string, id?: string, options: any = {}): RequestArgs {
            // verify required parameter 'couponCode' is not null or undefined
            if (couponCode === null || couponCode === undefined) {
                throw new RequiredError('couponCode','Required parameter couponCode was null or undefined when calling addCouponToShoppingCart.');
            }
            const localVarPath = `/shopping-cart/coupon`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (shopCode !== undefined) {
                localVarQueryParameter['shopCode'] = shopCode;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (couponCode !== undefined) {
                localVarQueryParameter['couponCode'] = couponCode;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingCartItemDto' is not null or undefined
            if (shoppingCartItemDto === null || shoppingCartItemDto === undefined) {
                throw new RequiredError('shoppingCartItemDto','Required parameter shoppingCartItemDto was null or undefined when calling addItemToShoppingCart.');
            }
            const localVarPath = `/shopping-cart`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ShoppingCartItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingCartItemDto !== undefined ? shoppingCartItemDto : {}) : (shoppingCartItemDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored. Returns the updated item.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {ShoppingCartRequestDto} shoppingCartRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCartNoDetail(shoppingCartRequestDto: ShoppingCartRequestDto, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingCartRequestDto' is not null or undefined
            if (shoppingCartRequestDto === null || shoppingCartRequestDto === undefined) {
                throw new RequiredError('shoppingCartRequestDto','Required parameter shoppingCartRequestDto was null or undefined when calling addItemToShoppingCartNoDetail.');
            }
            const localVarPath = `/shopping-cart-item`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ShoppingCartRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingCartRequestDto !== undefined ? shoppingCartRequestDto : {}) : (shoppingCartRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear your current shopping cart
         * @param {string} shopCode The shop code for  the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearShoppingCart(shopCode: string, id?: string, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling clearShoppingCart.');
            }
            const localVarPath = `/shopping-cart/clear`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (shopCode !== undefined) {
                localVarQueryParameter['shopCode'] = shopCode;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current status of your shopping cart
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCart(shopCode?: string, id?: string, options: any = {}): RequestArgs {
            const localVarPath = `/shopping-cart`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (shopCode !== undefined) {
                localVarQueryParameter['shopCode'] = shopCode;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Merge guest cart with the cart of the logged in user.
         * @param {ShoppingCartRequestDto} [shoppingCartRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeShoppingCarts(shoppingCartRequestDto?: ShoppingCartRequestDto, options: any = {}): RequestArgs {
            const localVarPath = `/shopping-cart/merge`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ShoppingCartRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingCartRequestDto !== undefined ? shoppingCartRequestDto : {}) : (shoppingCartRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears the coupon from your shopping cart
         * @summary Clears the coupon from your shopping cart
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCouponFromShoppingCart(shopCode?: string, id?: string, options: any = {}): RequestArgs {
            const localVarPath = `/shopping-cart/coupon`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (shopCode !== undefined) {
                localVarQueryParameter['shopCode'] = shopCode;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an item from your shopping cart
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingCartItemDto' is not null or undefined
            if (shoppingCartItemDto === null || shoppingCartItemDto === undefined) {
                throw new RequiredError('shoppingCartItemDto','Required parameter shoppingCartItemDto was null or undefined when calling removeItemFromShoppingCart.');
            }
            const localVarPath = `/shopping-cart`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ShoppingCartItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingCartItemDto !== undefined ? shoppingCartItemDto : {}) : (shoppingCartItemDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShoppingCartsApi - functional programming interface
 * @export
 */
export const ShoppingCartsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add items to your shopping cart or override existing ones. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
         * @summary Add all items to your shopping cart or override existing ones.
         * @param {Array<ShoppingCartItemDto>} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllItemsToShoppingCart(shoppingCartItemDto: Array<ShoppingCartItemDto>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).addAllItemsToShoppingCart(shoppingCartItemDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Add an coupon to your shopping cart or override the exsiting one.
         * @summary Add a coupon to your shopping cart or override the existing one and return the added coupon.
         * @param {string} couponCode The coupon code to be added to the shopping cart.
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponToShoppingCart(couponCode: string, shopCode?: string, id?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponDto> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).addCouponToShoppingCart(couponCode, shopCode, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).addItemToShoppingCart(shoppingCartItemDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored. Returns the updated item.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {ShoppingCartRequestDto} shoppingCartRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCartNoDetail(shoppingCartRequestDto: ShoppingCartRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItemDto> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).addItemToShoppingCartNoDetail(shoppingCartRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Clear your current shopping cart
         * @param {string} shopCode The shop code for  the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearShoppingCart(shopCode: string, id?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).clearShoppingCart(shopCode, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the current status of your shopping cart
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCart(shopCode?: string, id?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartDto> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).getShoppingCart(shopCode, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Merge guest cart with the cart of the logged in user.
         * @param {ShoppingCartRequestDto} [shoppingCartRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeShoppingCarts(shoppingCartRequestDto?: ShoppingCartRequestDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).mergeShoppingCarts(shoppingCartRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Clears the coupon from your shopping cart
         * @summary Clears the coupon from your shopping cart
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCouponFromShoppingCart(shopCode?: string, id?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).removeCouponFromShoppingCart(shopCode, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove an item from your shopping cart
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ShoppingCartsApiAxiosParamCreator(configuration).removeItemFromShoppingCart(shoppingCartItemDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ShoppingCartsApi - factory interface
 * @export
 */
export const ShoppingCartsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add items to your shopping cart or override existing ones. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
         * @summary Add all items to your shopping cart or override existing ones.
         * @param {Array<ShoppingCartItemDto>} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllItemsToShoppingCart(shoppingCartItemDto: Array<ShoppingCartItemDto>, options?: any) {
            return ShoppingCartsApiFp(configuration).addAllItemsToShoppingCart(shoppingCartItemDto, options)(axios, basePath);
        },
        /**
         * Add an coupon to your shopping cart or override the exsiting one.
         * @summary Add a coupon to your shopping cart or override the existing one and return the added coupon.
         * @param {string} couponCode The coupon code to be added to the shopping cart.
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCouponToShoppingCart(couponCode: string, shopCode?: string, id?: string, options?: any) {
            return ShoppingCartsApiFp(configuration).addCouponToShoppingCart(couponCode, shopCode, id, options)(axios, basePath);
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
            return ShoppingCartsApiFp(configuration).addItemToShoppingCart(shoppingCartItemDto, options)(axios, basePath);
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored. Returns the updated item.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {ShoppingCartRequestDto} shoppingCartRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCartNoDetail(shoppingCartRequestDto: ShoppingCartRequestDto, options?: any) {
            return ShoppingCartsApiFp(configuration).addItemToShoppingCartNoDetail(shoppingCartRequestDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Clear your current shopping cart
         * @param {string} shopCode The shop code for  the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearShoppingCart(shopCode: string, id?: string, options?: any) {
            return ShoppingCartsApiFp(configuration).clearShoppingCart(shopCode, id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get the current status of your shopping cart
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCart(shopCode?: string, id?: string, options?: any) {
            return ShoppingCartsApiFp(configuration).getShoppingCart(shopCode, id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Merge guest cart with the cart of the logged in user.
         * @param {ShoppingCartRequestDto} [shoppingCartRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeShoppingCarts(shoppingCartRequestDto?: ShoppingCartRequestDto, options?: any) {
            return ShoppingCartsApiFp(configuration).mergeShoppingCarts(shoppingCartRequestDto, options)(axios, basePath);
        },
        /**
         * Clears the coupon from your shopping cart
         * @summary Clears the coupon from your shopping cart
         * @param {string} [shopCode] The shop code for the requested shopping cart.
         * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCouponFromShoppingCart(shopCode?: string, id?: string, options?: any) {
            return ShoppingCartsApiFp(configuration).removeCouponFromShoppingCart(shopCode, id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Remove an item from your shopping cart
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
            return ShoppingCartsApiFp(configuration).removeItemFromShoppingCart(shoppingCartItemDto, options)(axios, basePath);
        },
    };
};

/**
 * ShoppingCartsApi - object-oriented interface
 * @export
 * @class ShoppingCartsApi
 * @extends {BaseAPI}
 */
export class ShoppingCartsApi extends BaseAPI {
    /**
     * Add items to your shopping cart or override existing ones. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
     * @summary Add all items to your shopping cart or override existing ones.
     * @param {Array<ShoppingCartItemDto>} shoppingCartItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public addAllItemsToShoppingCart(shoppingCartItemDto: Array<ShoppingCartItemDto>, options?: any) {
        return ShoppingCartsApiFp(this.configuration).addAllItemsToShoppingCart(shoppingCartItemDto, options)(this.axios, this.basePath);
    }

    /**
     * Add an coupon to your shopping cart or override the exsiting one.
     * @summary Add a coupon to your shopping cart or override the existing one and return the added coupon.
     * @param {string} couponCode The coupon code to be added to the shopping cart.
     * @param {string} [shopCode] The shop code for the requested shopping cart.
     * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public addCouponToShoppingCart(couponCode: string, shopCode?: string, id?: string, options?: any) {
        return ShoppingCartsApiFp(this.configuration).addCouponToShoppingCart(couponCode, shopCode, id, options)(this.axios, this.basePath);
    }

    /**
     * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored.
     * @summary Add an item to your shopping cart or override an existing one
     * @param {ShoppingCartItemDto} shoppingCartItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public addItemToShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
        return ShoppingCartsApiFp(this.configuration).addItemToShoppingCart(shoppingCartItemDto, options)(this.axios, this.basePath);
    }

    /**
     * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (sku etc.) are used for determining the primary key, any entities sent with the request will be ignored. Returns the updated item.
     * @summary Add an item to your shopping cart or override an existing one
     * @param {ShoppingCartRequestDto} shoppingCartRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public addItemToShoppingCartNoDetail(shoppingCartRequestDto: ShoppingCartRequestDto, options?: any) {
        return ShoppingCartsApiFp(this.configuration).addItemToShoppingCartNoDetail(shoppingCartRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Clear your current shopping cart
     * @param {string} shopCode The shop code for  the requested shopping cart.
     * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public clearShoppingCart(shopCode: string, id?: string, options?: any) {
        return ShoppingCartsApiFp(this.configuration).clearShoppingCart(shopCode, id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get the current status of your shopping cart
     * @param {string} [shopCode] The shop code for the requested shopping cart.
     * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public getShoppingCart(shopCode?: string, id?: string, options?: any) {
        return ShoppingCartsApiFp(this.configuration).getShoppingCart(shopCode, id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Merge guest cart with the cart of the logged in user.
     * @param {ShoppingCartRequestDto} [shoppingCartRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public mergeShoppingCarts(shoppingCartRequestDto?: ShoppingCartRequestDto, options?: any) {
        return ShoppingCartsApiFp(this.configuration).mergeShoppingCarts(shoppingCartRequestDto, options)(this.axios, this.basePath);
    }

    /**
     * Clears the coupon from your shopping cart
     * @summary Clears the coupon from your shopping cart
     * @param {string} [shopCode] The shop code for the requested shopping cart.
     * @param {string} [id] The guestId if it is a guest shopping cart, otherwise empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public removeCouponFromShoppingCart(shopCode?: string, id?: string, options?: any) {
        return ShoppingCartsApiFp(this.configuration).removeCouponFromShoppingCart(shopCode, id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Remove an item from your shopping cart
     * @param {ShoppingCartItemDto} shoppingCartItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public removeItemFromShoppingCart(shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
        return ShoppingCartsApiFp(this.configuration).removeItemFromShoppingCart(shoppingCartItemDto, options)(this.axios, this.basePath);
    }

}


/**
 * ShoppingListsApi - axios parameter creator
 * @export
 */
export const ShoppingListsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new item to the shopping list or update the amount of an already existing one.
         * @summary Add an item to the shopping list or update an existing one.
         * @param {number} shoppingListId The shopping list id
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingListId' is not null or undefined
            if (shoppingListId === null || shoppingListId === undefined) {
                throw new RequiredError('shoppingListId','Required parameter shoppingListId was null or undefined when calling addUserShoppingListItem.');
            }
            // verify required parameter 'shoppingCartItemDto' is not null or undefined
            if (shoppingCartItemDto === null || shoppingCartItemDto === undefined) {
                throw new RequiredError('shoppingCartItemDto','Required parameter shoppingCartItemDto was null or undefined when calling addUserShoppingListItem.');
            }
            const localVarPath = `/my/shopping-list/{shoppingListId}/item`
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ShoppingCartItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingCartItemDto !== undefined ? shoppingCartItemDto : {}) : (shoppingCartItemDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The given shoppingListIds represent the shopping lists to change. Adds an item to all given shopping lists where the item was not already in the list. Removes an item from all given shopping lists where the item was contained.
         * @summary Add or remove an item from multiple shopping lists.
         * @param {MultipleShoppingListsItemDto} multipleShoppingListsItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeItemInMultipleShoppingLists(multipleShoppingListsItemDto: MultipleShoppingListsItemDto, options: any = {}): RequestArgs {
            // verify required parameter 'multipleShoppingListsItemDto' is not null or undefined
            if (multipleShoppingListsItemDto === null || multipleShoppingListsItemDto === undefined) {
                throw new RequiredError('multipleShoppingListsItemDto','Required parameter multipleShoppingListsItemDto was null or undefined when calling changeItemInMultipleShoppingLists.');
            }
            const localVarPath = `/my/shopping-lists/addOrRemoveItem`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"MultipleShoppingListsItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(multipleShoppingListsItemDto !== undefined ? multipleShoppingListsItemDto : {}) : (multipleShoppingListsItemDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new shopping list for the current user.
         * @param {ShoppingListDto} shoppingListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserShoppingList(shoppingListDto: ShoppingListDto, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingListDto' is not null or undefined
            if (shoppingListDto === null || shoppingListDto === undefined) {
                throw new RequiredError('shoppingListDto','Required parameter shoppingListDto was null or undefined when calling createUserShoppingList.');
            }
            const localVarPath = `/my/shopping-lists`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ShoppingListDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingListDto !== undefined ? shoppingListDto : {}) : (shoppingListDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the shopping list of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserShoppingListById(shoppingListId: number, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingListId' is not null or undefined
            if (shoppingListId === null || shoppingListId === undefined) {
                throw new RequiredError('shoppingListId','Required parameter shoppingListId was null or undefined when calling deleteUserShoppingListById.');
            }
            const localVarPath = `/my/shopping-list/{shoppingListId}`
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a shopping list of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShoppingListById(shoppingListId: number, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingListId' is not null or undefined
            if (shoppingListId === null || shoppingListId === undefined) {
                throw new RequiredError('shoppingListId','Required parameter shoppingListId was null or undefined when calling getUserShoppingListById.');
            }
            const localVarPath = `/my/shopping-list/{shoppingListId}`
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all shopping list meta infos of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShoppingListsMetadata(options: any = {}): RequestArgs {
            const localVarPath = `/my/shopping-lists`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the an existing item from the shopping list.
         * @summary Delete an existing item from the shopping list.
         * @param {number} shoppingListId The shopping list id
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingListId' is not null or undefined
            if (shoppingListId === null || shoppingListId === undefined) {
                throw new RequiredError('shoppingListId','Required parameter shoppingListId was null or undefined when calling removeUserShoppingListItem.');
            }
            // verify required parameter 'shoppingCartItemDto' is not null or undefined
            if (shoppingCartItemDto === null || shoppingCartItemDto === undefined) {
                throw new RequiredError('shoppingCartItemDto','Required parameter shoppingCartItemDto was null or undefined when calling removeUserShoppingListItem.');
            }
            const localVarPath = `/my/shopping-list/{shoppingListId}/item`
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ShoppingCartItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(shoppingCartItemDto !== undefined ? shoppingCartItemDto : {}) : (shoppingCartItemDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the shopping list title of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserShoppingListTitle(shoppingListId: number, body: string, options: any = {}): RequestArgs {
            // verify required parameter 'shoppingListId' is not null or undefined
            if (shoppingListId === null || shoppingListId === undefined) {
                throw new RequiredError('shoppingListId','Required parameter shoppingListId was null or undefined when calling updateUserShoppingListTitle.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateUserShoppingListTitle.');
            }
            const localVarPath = `/my/shopping-list/{shoppingListId}`
                .replace(`{${"shoppingListId"}}`, encodeURIComponent(String(shoppingListId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'text/plain';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShoppingListsApi - functional programming interface
 * @export
 */
export const ShoppingListsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a new item to the shopping list or update the amount of an already existing one.
         * @summary Add an item to the shopping list or update an existing one.
         * @param {number} shoppingListId The shopping list id
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingListDto> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).addUserShoppingListItem(shoppingListId, shoppingCartItemDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * The given shoppingListIds represent the shopping lists to change. Adds an item to all given shopping lists where the item was not already in the list. Removes an item from all given shopping lists where the item was contained.
         * @summary Add or remove an item from multiple shopping lists.
         * @param {MultipleShoppingListsItemDto} multipleShoppingListsItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeItemInMultipleShoppingLists(multipleShoppingListsItemDto: MultipleShoppingListsItemDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShoppingListMetadataDto>> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).changeItemInMultipleShoppingLists(multipleShoppingListsItemDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a new shopping list for the current user.
         * @param {ShoppingListDto} shoppingListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserShoppingList(shoppingListDto: ShoppingListDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingListDto> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).createUserShoppingList(shoppingListDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Delete the shopping list of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserShoppingListById(shoppingListId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).deleteUserShoppingListById(shoppingListId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a shopping list of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShoppingListById(shoppingListId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingListDto> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).getUserShoppingListById(shoppingListId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all shopping list meta infos of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShoppingListsMetadata(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShoppingListMetadataDto>> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).getUserShoppingListsMetadata(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete the an existing item from the shopping list.
         * @summary Delete an existing item from the shopping list.
         * @param {number} shoppingListId The shopping list id
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingListDto> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).removeUserShoppingListItem(shoppingListId, shoppingCartItemDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update the shopping list title of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserShoppingListTitle(shoppingListId: number, body: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingListDto> {
            const localVarAxiosArgs = ShoppingListsApiAxiosParamCreator(configuration).updateUserShoppingListTitle(shoppingListId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ShoppingListsApi - factory interface
 * @export
 */
export const ShoppingListsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a new item to the shopping list or update the amount of an already existing one.
         * @summary Add an item to the shopping list or update an existing one.
         * @param {number} shoppingListId The shopping list id
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
            return ShoppingListsApiFp(configuration).addUserShoppingListItem(shoppingListId, shoppingCartItemDto, options)(axios, basePath);
        },
        /**
         * The given shoppingListIds represent the shopping lists to change. Adds an item to all given shopping lists where the item was not already in the list. Removes an item from all given shopping lists where the item was contained.
         * @summary Add or remove an item from multiple shopping lists.
         * @param {MultipleShoppingListsItemDto} multipleShoppingListsItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeItemInMultipleShoppingLists(multipleShoppingListsItemDto: MultipleShoppingListsItemDto, options?: any) {
            return ShoppingListsApiFp(configuration).changeItemInMultipleShoppingLists(multipleShoppingListsItemDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Create a new shopping list for the current user.
         * @param {ShoppingListDto} shoppingListDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserShoppingList(shoppingListDto: ShoppingListDto, options?: any) {
            return ShoppingListsApiFp(configuration).createUserShoppingList(shoppingListDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Delete the shopping list of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserShoppingListById(shoppingListId: number, options?: any) {
            return ShoppingListsApiFp(configuration).deleteUserShoppingListById(shoppingListId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get a shopping list of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShoppingListById(shoppingListId: number, options?: any) {
            return ShoppingListsApiFp(configuration).getUserShoppingListById(shoppingListId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get all shopping list meta infos of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShoppingListsMetadata(options?: any) {
            return ShoppingListsApiFp(configuration).getUserShoppingListsMetadata(options)(axios, basePath);
        },
        /**
         * Delete the an existing item from the shopping list.
         * @summary Delete an existing item from the shopping list.
         * @param {number} shoppingListId The shopping list id
         * @param {ShoppingCartItemDto} shoppingCartItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
            return ShoppingListsApiFp(configuration).removeUserShoppingListItem(shoppingListId, shoppingCartItemDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update the shopping list title of the current user.
         * @param {number} shoppingListId The shopping list id
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserShoppingListTitle(shoppingListId: number, body: string, options?: any) {
            return ShoppingListsApiFp(configuration).updateUserShoppingListTitle(shoppingListId, body, options)(axios, basePath);
        },
    };
};

/**
 * ShoppingListsApi - object-oriented interface
 * @export
 * @class ShoppingListsApi
 * @extends {BaseAPI}
 */
export class ShoppingListsApi extends BaseAPI {
    /**
     * Add a new item to the shopping list or update the amount of an already existing one.
     * @summary Add an item to the shopping list or update an existing one.
     * @param {number} shoppingListId The shopping list id
     * @param {ShoppingCartItemDto} shoppingCartItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public addUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
        return ShoppingListsApiFp(this.configuration).addUserShoppingListItem(shoppingListId, shoppingCartItemDto, options)(this.axios, this.basePath);
    }

    /**
     * The given shoppingListIds represent the shopping lists to change. Adds an item to all given shopping lists where the item was not already in the list. Removes an item from all given shopping lists where the item was contained.
     * @summary Add or remove an item from multiple shopping lists.
     * @param {MultipleShoppingListsItemDto} multipleShoppingListsItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public changeItemInMultipleShoppingLists(multipleShoppingListsItemDto: MultipleShoppingListsItemDto, options?: any) {
        return ShoppingListsApiFp(this.configuration).changeItemInMultipleShoppingLists(multipleShoppingListsItemDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Create a new shopping list for the current user.
     * @param {ShoppingListDto} shoppingListDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public createUserShoppingList(shoppingListDto: ShoppingListDto, options?: any) {
        return ShoppingListsApiFp(this.configuration).createUserShoppingList(shoppingListDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Delete the shopping list of the current user.
     * @param {number} shoppingListId The shopping list id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public deleteUserShoppingListById(shoppingListId: number, options?: any) {
        return ShoppingListsApiFp(this.configuration).deleteUserShoppingListById(shoppingListId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get a shopping list of the current user.
     * @param {number} shoppingListId The shopping list id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public getUserShoppingListById(shoppingListId: number, options?: any) {
        return ShoppingListsApiFp(this.configuration).getUserShoppingListById(shoppingListId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get all shopping list meta infos of the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public getUserShoppingListsMetadata(options?: any) {
        return ShoppingListsApiFp(this.configuration).getUserShoppingListsMetadata(options)(this.axios, this.basePath);
    }

    /**
     * Delete the an existing item from the shopping list.
     * @summary Delete an existing item from the shopping list.
     * @param {number} shoppingListId The shopping list id
     * @param {ShoppingCartItemDto} shoppingCartItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public removeUserShoppingListItem(shoppingListId: number, shoppingCartItemDto: ShoppingCartItemDto, options?: any) {
        return ShoppingListsApiFp(this.configuration).removeUserShoppingListItem(shoppingListId, shoppingCartItemDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update the shopping list title of the current user.
     * @param {number} shoppingListId The shopping list id
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingListsApi
     */
    public updateUserShoppingListTitle(shoppingListId: number, body: string, options?: any) {
        return ShoppingListsApiFp(this.configuration).updateUserShoppingListTitle(shoppingListId, body, options)(this.axios, this.basePath);
    }

}


/**
 * ShopsApi - axios parameter creator
 * @export
 */
export const ShopsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the settings of a shop
         * @param {string} shopCode The code of the shop to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(shopCode: string, options: any = {}): RequestArgs {
            // verify required parameter 'shopCode' is not null or undefined
            if (shopCode === null || shopCode === undefined) {
                throw new RequiredError('shopCode','Required parameter shopCode was null or undefined when calling getSettings.');
            }
            const localVarPath = `/shop/{shopCode}/settings`
                .replace(`{${"shopCode"}}`, encodeURIComponent(String(shopCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopsApi - functional programming interface
 * @export
 */
export const ShopsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the settings of a shop
         * @param {string} shopCode The code of the shop to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(shopCode: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopSettingsDto> {
            const localVarAxiosArgs = ShopsApiAxiosParamCreator(configuration).getSettings(shopCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ShopsApi - factory interface
 * @export
 */
export const ShopsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get the settings of a shop
         * @param {string} shopCode The code of the shop to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(shopCode: string, options?: any) {
            return ShopsApiFp(configuration).getSettings(shopCode, options)(axios, basePath);
        },
    };
};

/**
 * ShopsApi - object-oriented interface
 * @export
 * @class ShopsApi
 * @extends {BaseAPI}
 */
export class ShopsApi extends BaseAPI {
    /**
     * 
     * @summary Get the settings of a shop
     * @param {string} shopCode The code of the shop to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopsApi
     */
    public getSettings(shopCode: string, options?: any) {
        return ShopsApiFp(this.configuration).getSettings(shopCode, options)(this.axios, this.basePath);
    }

}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a user in the database
         * @param {UserRegistrationDto} userRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userRegistrationDto: UserRegistrationDto, options: any = {}): RequestArgs {
            // verify required parameter 'userRegistrationDto' is not null or undefined
            if (userRegistrationDto === null || userRegistrationDto === undefined) {
                throw new RequiredError('userRegistrationDto','Required parameter userRegistrationDto was null or undefined when calling createUser.');
            }
            const localVarPath = `/my/registration/finish`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UserRegistrationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userRegistrationDto !== undefined ? userRegistrationDto : {}) : (userRegistrationDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get confirmation email addresses of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationEmails(options: any = {}): RequestArgs {
            const localVarPath = `/my/confirmation-emails`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options: any = {}): RequestArgs {
            const localVarPath = `/my/getCurrentUser`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all invoices of a user
         * @param {'invoice' | 'creditmemo' | 'deliverynote'} type 
         * @param {number} [pageNumber] Page number
         * @param {number} [pageSize] Page size
         * @param {'ASC' | 'DESC'} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInvoices(type: 'invoice' | 'creditmemo' | 'deliverynote', pageNumber?: number, pageSize?: number, sortDirection?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling getUserInvoices.');
            }
            const localVarPath = `/my/receipt/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the list page size saved by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPageSize(options: any = {}): RequestArgs {
            const localVarPath = `/my/pagesize`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a receipt of an user as PDF
         * @param {string} documentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReceiptPdf(documentNumber: string, options: any = {}): RequestArgs {
            // verify required parameter 'documentNumber' is not null or undefined
            if (documentNumber === null || documentNumber === undefined) {
                throw new RequiredError('documentNumber','Required parameter documentNumber was null or undefined when calling getUserReceiptPdf.');
            }
            const localVarPath = `/my/receipt/{documentNumber}/pdf`
                .replace(`{${"documentNumber"}}`, encodeURIComponent(String(documentNumber)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the default billing address of the current user
         * @param {number} addressId The new default billing address id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultBillingAddress(addressId: number, options: any = {}): RequestArgs {
            // verify required parameter 'addressId' is not null or undefined
            if (addressId === null || addressId === undefined) {
                throw new RequiredError('addressId','Required parameter addressId was null or undefined when calling updateDefaultBillingAddress.');
            }
            const localVarPath = `/my/default-billing-address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (addressId !== undefined) {
                localVarQueryParameter['addressId'] = addressId;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the default delivery address of the current user
         * @param {number} addressId The new default delivery address id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultDeliveryAddress(addressId: number, options: any = {}): RequestArgs {
            // verify required parameter 'addressId' is not null or undefined
            if (addressId === null || addressId === undefined) {
                throw new RequiredError('addressId','Required parameter addressId was null or undefined when calling updateDefaultDeliveryAddress.');
            }
            const localVarPath = `/my/default-delivery-address`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (addressId !== undefined) {
                localVarQueryParameter['addressId'] = addressId;
            }


                localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the current user
         * @param {UserSubmitDto} userSubmitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData(userSubmitDto: UserSubmitDto, options: any = {}): RequestArgs {
            // verify required parameter 'userSubmitDto' is not null or undefined
            if (userSubmitDto === null || userSubmitDto === undefined) {
                throw new RequiredError('userSubmitDto','Required parameter userSubmitDto was null or undefined when calling updateUserData.');
            }
            const localVarPath = `/my/updateUserData`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UserSubmitDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userSubmitDto !== undefined ? userSubmitDto : {}) : (userSubmitDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the language setting saved by the current user
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLanguage(body: string, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateUserLanguage.');
            }
            const localVarPath = `/my/language`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'text/plain';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the list page size saved by the current user
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPageSize(body: number, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateUserPageSize.');
            }
            const localVarPath = `/my/pagesize`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("BearerAuth", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


                localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"number" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a user in the database
         * @param {UserRegistrationDto} userRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userRegistrationDto: UserRegistrationDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).createUser(userRegistrationDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get confirmation email addresses of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationEmails(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getConfirmationEmails(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getCurrentUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets all invoices of a user
         * @param {'invoice' | 'creditmemo' | 'deliverynote'} type 
         * @param {number} [pageNumber] Page number
         * @param {number} [pageSize] Page size
         * @param {'ASC' | 'DESC'} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInvoices(type: 'invoice' | 'creditmemo' | 'deliverynote', pageNumber?: number, pageSize?: number, sortDirection?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicesDto> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getUserInvoices(type, pageNumber, pageSize, sortDirection, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the list page size saved by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPageSize(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getUserPageSize(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a receipt of an user as PDF
         * @param {string} documentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReceiptPdf(documentNumber: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).getUserReceiptPdf(documentNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update the default billing address of the current user
         * @param {number} addressId The new default billing address id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultBillingAddress(addressId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateDefaultBillingAddress(addressId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update the default delivery address of the current user
         * @param {number} addressId The new default delivery address id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultDeliveryAddress(addressId: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateDefaultDeliveryAddress(addressId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates the current user
         * @param {UserSubmitDto} userSubmitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData(userSubmitDto: UserSubmitDto, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateUserData(userSubmitDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update the language setting saved by the current user
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLanguage(body: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateUserLanguage(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update the list page size saved by the current user
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPageSize(body: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = UsersApiAxiosParamCreator(configuration).updateUserPageSize(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a user in the database
         * @param {UserRegistrationDto} userRegistrationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userRegistrationDto: UserRegistrationDto, options?: any) {
            return UsersApiFp(configuration).createUser(userRegistrationDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get confirmation email addresses of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationEmails(options?: any) {
            return UsersApiFp(configuration).getConfirmationEmails(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any) {
            return UsersApiFp(configuration).getCurrentUser(options)(axios, basePath);
        },
        /**
         * 
         * @summary Gets all invoices of a user
         * @param {'invoice' | 'creditmemo' | 'deliverynote'} type 
         * @param {number} [pageNumber] Page number
         * @param {number} [pageSize] Page size
         * @param {'ASC' | 'DESC'} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInvoices(type: 'invoice' | 'creditmemo' | 'deliverynote', pageNumber?: number, pageSize?: number, sortDirection?: 'ASC' | 'DESC', options?: any) {
            return UsersApiFp(configuration).getUserInvoices(type, pageNumber, pageSize, sortDirection, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get the list page size saved by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPageSize(options?: any) {
            return UsersApiFp(configuration).getUserPageSize(options)(axios, basePath);
        },
        /**
         * 
         * @summary Get a receipt of an user as PDF
         * @param {string} documentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReceiptPdf(documentNumber: string, options?: any) {
            return UsersApiFp(configuration).getUserReceiptPdf(documentNumber, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update the default billing address of the current user
         * @param {number} addressId The new default billing address id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultBillingAddress(addressId: number, options?: any) {
            return UsersApiFp(configuration).updateDefaultBillingAddress(addressId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update the default delivery address of the current user
         * @param {number} addressId The new default delivery address id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultDeliveryAddress(addressId: number, options?: any) {
            return UsersApiFp(configuration).updateDefaultDeliveryAddress(addressId, options)(axios, basePath);
        },
        /**
         * 
         * @summary Updates the current user
         * @param {UserSubmitDto} userSubmitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData(userSubmitDto: UserSubmitDto, options?: any) {
            return UsersApiFp(configuration).updateUserData(userSubmitDto, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update the language setting saved by the current user
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLanguage(body: string, options?: any) {
            return UsersApiFp(configuration).updateUserLanguage(body, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update the list page size saved by the current user
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPageSize(body: number, options?: any) {
            return UsersApiFp(configuration).updateUserPageSize(body, options)(axios, basePath);
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Create a user in the database
     * @param {UserRegistrationDto} userRegistrationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(userRegistrationDto: UserRegistrationDto, options?: any) {
        return UsersApiFp(this.configuration).createUser(userRegistrationDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get confirmation email addresses of current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getConfirmationEmails(options?: any) {
        return UsersApiFp(this.configuration).getConfirmationEmails(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCurrentUser(options?: any) {
        return UsersApiFp(this.configuration).getCurrentUser(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Gets all invoices of a user
     * @param {'invoice' | 'creditmemo' | 'deliverynote'} type 
     * @param {number} [pageNumber] Page number
     * @param {number} [pageSize] Page size
     * @param {'ASC' | 'DESC'} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserInvoices(type: 'invoice' | 'creditmemo' | 'deliverynote', pageNumber?: number, pageSize?: number, sortDirection?: 'ASC' | 'DESC', options?: any) {
        return UsersApiFp(this.configuration).getUserInvoices(type, pageNumber, pageSize, sortDirection, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get the list page size saved by the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserPageSize(options?: any) {
        return UsersApiFp(this.configuration).getUserPageSize(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get a receipt of an user as PDF
     * @param {string} documentNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserReceiptPdf(documentNumber: string, options?: any) {
        return UsersApiFp(this.configuration).getUserReceiptPdf(documentNumber, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update the default billing address of the current user
     * @param {number} addressId The new default billing address id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateDefaultBillingAddress(addressId: number, options?: any) {
        return UsersApiFp(this.configuration).updateDefaultBillingAddress(addressId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update the default delivery address of the current user
     * @param {number} addressId The new default delivery address id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateDefaultDeliveryAddress(addressId: number, options?: any) {
        return UsersApiFp(this.configuration).updateDefaultDeliveryAddress(addressId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Updates the current user
     * @param {UserSubmitDto} userSubmitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserData(userSubmitDto: UserSubmitDto, options?: any) {
        return UsersApiFp(this.configuration).updateUserData(userSubmitDto, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update the language setting saved by the current user
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserLanguage(body: string, options?: any) {
        return UsersApiFp(this.configuration).updateUserLanguage(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update the list page size saved by the current user
     * @param {number} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserPageSize(body: number, options?: any) {
        return UsersApiFp(this.configuration).updateUserPageSize(body, options)(this.axios, this.basePath);
    }

}


